
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("k2J4N", function(module, exports) {

$parcel$export(module.exports, "SingleLineSmartLink", () => $9b904c147e4dc6d4$export$dfeef178fa5021ea);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8dO33 = parcelRequire("8dO33");

var $kVZJG = parcelRequire("kVZJG");
var $dn5wJ = parcelRequire("dn5wJ");
var $8dVIb = parcelRequire("8dVIb");
var $buvhv = parcelRequire("buvhv");
const $9b904c147e4dc6d4$var$smartLinkStyles = null;
const $9b904c147e4dc6d4$export$dfeef178fa5021ea = /*#__PURE__*/ (0, $5uXOq.memo)(({ props: { url: url, anchorTarget: anchorTarget, text: text, fieldType: fieldType = 'url' } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b904c147e4dc6d4$var$LinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVZJG.Card), {
        appearance: "inline",
        url: url,
        ui: {
            hidePadding: true,
            clickableContainer: true
        },
        frameStyle: "hide",
        showHoverPreview: true,
        actionOptions: {
            hide: false,
            exclude: [
                (0, $dn5wJ.CardAction).ChangeStatusAction
            ]
        },
        analyticsContext: {
            attributes: {
                fieldType: fieldType
            }
        },
        onClick: (event)=>event.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buvhv.default), {
        hideTitleTooltip: true,
        maxLines: 1,
        metadata: [
            {
                name: (0, $8dVIb.ElementName).State
            }
        ],
        anchorTarget: anchorTarget ?? '_self',
        text: text,
        className: (0, $bwpsq.default)([
            "_ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _1j14idpf _19ugkb7n _1pnh1wug _alr39jpi _1uk8idpf _18xlidpf _rxo61wug _6319idpf _ui2w1h6o _xhmn1e5h"
        ])
    })))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $9b904c147e4dc6d4$var$LinkContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1vzot9bt _12uwidpf _1ftqidpf _7wrtidpf _1gonidpf _9ph44jg8 _1ort1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kVZJG", function(module, exports) {

$parcel$export(module.exports, "Card", () => $fc8afc0c39cee453$export$60332b2344f7fe41);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $fzJZi = parcelRequire("fzJZi");

var $lpxJ1 = parcelRequire("lpxJ1");
class $fc8afc0c39cee453$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lpxJ1.CardWithURLRenderer), {
            ...this.props
        });
        return this.props.intl ? content : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: content
        });
    }
}
const $fc8afc0c39cee453$export$60332b2344f7fe41 = (0, $994MI.default)((0, $fzJZi.context))((0, $cb25w.default)()((0, $8RXs9.default)($fc8afc0c39cee453$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("fzJZi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3b4d25437cc28513$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3b4d25437cc28513$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3b4d25437cc28513$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3b4d25437cc28513$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3b4d25437cc28513$export$b91e0203b928470c);
const $3b4d25437cc28513$export$85183a312807388d = 'media';
const $3b4d25437cc28513$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3b4d25437cc28513$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3b4d25437cc28513$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3b4d25437cc28513$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3b4d25437cc28513$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
};

});

parcelRegister("lpxJ1", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $422a0598dbbdc42a$export$e00a7788e30dc998);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $gKZoD = parcelRequire("gKZoD");

var $7Jxgt = parcelRequire("7Jxgt");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $kxcRq = parcelRequire("kxcRq");

var $5igsJ = parcelRequire("5igsJ");

var $91tw3 = parcelRequire("91tw3");

var $5vDFA = parcelRequire("5vDFA");

var $i41Ob = parcelRequire("i41Ob");

const $422a0598dbbdc42a$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(0, $kxcRq.importWithRetry)(()=>(parcelRequire("5HNFf"))));
function $422a0598dbbdc42a$export$e00a7788e30dc998(props) {
    (0, $gKZoD.di)($422a0598dbbdc42a$export$a7690c318cd6a95e);
    const [id] = (0, $5uXOq.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $5vDFA.clearMarks)(id);
            (0, $5vDFA.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline } = props;
    const isFlexibleUi = (0, $91tw3.isFlexibleUiCard)(children, (0, $VSDnB.fg)('platform-linking-flexible-card-openness') ? ui : undefined);
    const analyticsContext = (0, $5igsJ.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $5uXOq.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $1VPdD.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1VPdD.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1VPdD.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)(FallbackComponent, {});
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i41Ob.LoadingCardLink), {
                ...cardWithUrlProps
            }),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($422a0598dbbdc42a$export$a7690c318cd6a95e, {
                ...cardWithUrlProps,
                children: children
            })
        })
    });
}

});
parcelRegister("a1vqi", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $91130a451fd4887d$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");


var $1PQcU = parcelRequire("1PQcU");
const $91130a451fd4887d$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $1PQcU.default)(...params));
        event.fire((0, $37b399a913bad22b$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $37b399a913bad22b$export$3f072f06b90c3985 = 'media';

parcelRegister("1PQcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $539e70e97f68df84$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $539e70e97f68df84$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $539e70e97f68df84$export$2e2bcd8739ae039 = $539e70e97f68df84$var$createEventPayload;

});


parcelRegister("1VPdD", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $2308e6f5aae12b86$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $2308e6f5aae12b86$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $2308e6f5aae12b86$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $2308e6f5aae12b86$export$4084c0df4a03a6af);

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
const $2308e6f5aae12b86$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
};
const $2308e6f5aae12b86$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$ufoExperiences = {
    'smart-link-rendered': new (0, $cBycP.ConcurrentExperience)('smart-link-rendered', $2308e6f5aae12b86$var$renderExperience),
    'smart-link-authenticated': new (0, $cBycP.ConcurrentExperience)('smart-link-authenticated', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-action-invocation': new (0, $cBycP.ConcurrentExperience)('smart-link-action-invocation', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-ai-summary': new (0, $cBycP.ConcurrentExperience)('smart-link-ai-summary', $2308e6f5aae12b86$var$aiExperience)
};
const $2308e6f5aae12b86$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $2308e6f5aae12b86$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("kxcRq", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $c53851cced73411d$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $c53851cced73411d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $c53851cced73411d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $c53851cced73411d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $c53851cced73411d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $c53851cced73411d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $c53851cced73411d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $c53851cced73411d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $c53851cced73411d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $c53851cced73411d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $c53851cced73411d$export$d2b8fb9e780e17e7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $imVhc = parcelRequire("imVhc");

var $8dVIb = parcelRequire("8dVIb");

var $liAf6 = parcelRequire("liAf6");
const $c53851cced73411d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($c53851cced73411d$export$e6c5ffa684aac4d7() || $c53851cced73411d$export$d8de0cd37d316fdf(evt) || $c53851cced73411d$export$5b1771037ab7c451(evt));
const $c53851cced73411d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $c53851cced73411d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $VSDnB.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $c53851cced73411d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $c53851cced73411d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase()) : $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $c53851cced73411d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase()) : $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label] = icon;
    return label;
};


















































const $c53851cced73411d$var$typeToIcon = {
    'text/plain': [
        'Document',
        ()=>Promise.resolve((parcelRequire("duwKf")))
    ],
    'application/vnd.oasis.opendocument.text': [
        'Document',
        ()=>Promise.resolve((parcelRequire("duwKf")))
    ],
    'application/vnd.apple.pages': [
        'Document',
        ()=>Promise.resolve((parcelRequire("duwKf")))
    ],
    'application/vnd.google-apps.document': [
        'Google Doc',
        ()=>(parcelRequire("6q8Pr"))
    ],
    'application/msword': [
        'Word document',
        ()=>(parcelRequire("e3PhT"))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        'Word document',
        ()=>(parcelRequire("e3PhT"))
    ],
    'application/pdf': [
        'PDF document',
        ()=>(parcelRequire("55TA3"))
    ],
    'application/vnd.oasis.opendocument.spreadsheet': [
        'Spreadsheet',
        ()=>(parcelRequire("lb4t9"))
    ],
    'application/vnd.apple.numbers': [
        'Spreadsheet',
        ()=>(parcelRequire("lb4t9"))
    ],
    'application/vnd.google-apps.spreadsheet': [
        'Google Sheet',
        ()=>(parcelRequire("bwXIZ"))
    ],
    'application/vnd.ms-excel': [
        'Excel spreadsheet',
        ()=>(parcelRequire("8vv4H"))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        'Excel spreadsheet',
        ()=>(parcelRequire("8vv4H"))
    ],
    'application/vnd.oasis.opendocument.presentation': [
        'Presentation',
        ()=>(parcelRequire("2t9Hh"))
    ],
    'application/vnd.apple.keynote': [
        'Presentation',
        ()=>(parcelRequire("2t9Hh"))
    ],
    'application/vnd.google-apps.presentation': [
        'Google Slide',
        ()=>(parcelRequire("6SoQO"))
    ],
    'application/vnd.ms-powerpoint': [
        'PowerPoint presentation',
        ()=>(parcelRequire("TZHl8"))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        'PowerPoint presentation',
        ()=>(parcelRequire("TZHl8"))
    ],
    'application/vnd.google-apps.form': [
        'Google Form',
        ()=>(parcelRequire("3VL73"))
    ],
    'image/png': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/jpeg': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/bmp': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/webp': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/svg+xml': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/gif': [
        'GIF',
        ()=>(parcelRequire("eogSM"))
    ],
    'audio/midi': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/mpeg': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/webm': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/ogg': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/wav': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'video/mp4': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/quicktime': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/mov': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/webm': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/ogg': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/x-ms-wmv': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/x-msvideo': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'application/zip': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-tar': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-gtar': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-7z-compressed': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-apple-diskimage': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/vnd.rar': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/dmg': [
        'Executable',
        ()=>(parcelRequire("gmDdF"))
    ],
    'text/css': [
        'Source Code',
        ()=>(parcelRequire("coOzc"))
    ],
    'text/html': [
        'Source Code',
        ()=>(parcelRequire("coOzc"))
    ],
    'application/javascript': [
        'Source Code',
        ()=>(parcelRequire("coOzc"))
    ],
    'application/octet-stream': [
        'Binary file',
        ()=>(parcelRequire("ldQLy"))
    ],
    'application/invision.prototype': [
        'Prototype',
        ()=>(parcelRequire("ldQLy"))
    ],
    // TODO: Figure a way to detect those
    'application/sketch': [
        'Sketch',
        ()=>(parcelRequire("4WgJk"))
    ],
    folder: [
        'Folder',
        ()=>(parcelRequire("fjtI4"))
    ]
};

























































































const $c53851cced73411d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $8dVIb.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("94rku")))
        },
        [(0, $8dVIb.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("dVpJZ")))
        },
        [(0, $8dVIb.IconType).Audio]: {
            default: ()=>(parcelRequire("6ftoN"))
        },
        [(0, $8dVIb.IconType).Code]: {
            default: ()=>(parcelRequire("a0Blm"))
        },
        [(0, $8dVIb.IconType).File]: {
            default: ()=>(parcelRequire("gp1iV"))
        },
        [(0, $8dVIb.IconType).Folder]: {
            default: ()=>(parcelRequire("jJcF3"))
        },
        [(0, $8dVIb.IconType).Generic]: {
            default: ()=>(parcelRequire("gp1iV"))
        },
        [(0, $8dVIb.IconType).Image]: {
            default: ()=>(parcelRequire("eT6gz"))
        },
        [(0, $8dVIb.IconType).Presentation]: {
            default: ()=>(parcelRequire("fHKiX"))
        },
        [(0, $8dVIb.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("2UVok"))
        },
        [(0, $8dVIb.IconType).Video]: {
            default: ()=>(parcelRequire("3K7kY"))
        },
        [(0, $8dVIb.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("ckyDP")))
        },
        [(0, $8dVIb.IconType).Template]: {
            default: ()=>(parcelRequire("vxJ9s"))
        },
        [(0, $8dVIb.IconType).Forbidden]: {
            default: ()=>(parcelRequire("23MsP"))
        },
        [(0, $8dVIb.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("jOyH3")))
        },
        [(0, $8dVIb.IconType).Archive]: {
            default: ()=>(parcelRequire("4m4MY")),
            large: ()=>(parcelRequire("6jkTx"))
        },
        [(0, $8dVIb.IconType).Executable]: {
            default: ()=>(parcelRequire("gmDdF")),
            large: ()=>(parcelRequire("kWjiJ"))
        },
        [(0, $8dVIb.IconType).GIF]: {
            default: ()=>(parcelRequire("eogSM")),
            large: ()=>(parcelRequire("03kpR"))
        },
        [(0, $8dVIb.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("6q8Pr")),
            large: ()=>(parcelRequire("3rJ38"))
        },
        [(0, $8dVIb.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("3VL73")),
            large: ()=>(parcelRequire("jiAjo"))
        },
        [(0, $8dVIb.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("bwXIZ")),
            large: ()=>(parcelRequire("3hQB1"))
        },
        [(0, $8dVIb.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("6SoQO")),
            large: ()=>(parcelRequire("70xas"))
        },
        [(0, $8dVIb.IconType).MSExcel]: {
            default: ()=>(parcelRequire("8vv4H")),
            large: ()=>(parcelRequire("7P2U4"))
        },
        [(0, $8dVIb.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("TZHl8")),
            large: ()=>(parcelRequire("9Eo4X"))
        },
        [(0, $8dVIb.IconType).MSWord]: {
            default: ()=>(parcelRequire("e3PhT")),
            large: ()=>(parcelRequire("gBnqE"))
        },
        [(0, $8dVIb.IconType).PDF]: {
            default: ()=>(parcelRequire("55TA3")),
            large: ()=>(parcelRequire("eWGoe"))
        },
        [(0, $8dVIb.IconType).Sketch]: {
            default: ()=>(parcelRequire("4WgJk")),
            large: ()=>(parcelRequire("fu8cn"))
        },
        // Bitbucket icons
        [(0, $8dVIb.IconType).Branch]: {
            default: ()=>(parcelRequire("cAU6j")),
            large: ()=>(parcelRequire("4rggH"))
        },
        [(0, $8dVIb.IconType).Commit]: {
            default: ()=>(parcelRequire("bn2CC")),
            large: ()=>(parcelRequire("2nXLN"))
        },
        [(0, $8dVIb.IconType).PullRequest]: {
            default: ()=>(parcelRequire("cIR4U")),
            large: ()=>(parcelRequire("d4Msz"))
        },
        [(0, $8dVIb.IconType).Repo]: {
            default: ()=>(parcelRequire("bbgWK")),
            large: ()=>(parcelRequire("4Z42j"))
        },
        // Jira icons
        [(0, $8dVIb.IconType).Bug]: {
            default: ()=>(parcelRequire("jNgVH")),
            large: ()=>(parcelRequire("9LCHw"))
        },
        [(0, $8dVIb.IconType).Change]: {
            default: ()=>(parcelRequire("hhL96")),
            large: ()=>(parcelRequire("tyrb0"))
        },
        [(0, $8dVIb.IconType).Epic]: {
            default: ()=>(parcelRequire("9q15g")),
            large: ()=>(parcelRequire("fwsJh"))
        },
        [(0, $8dVIb.IconType).Incident]: {
            default: ()=>(parcelRequire("14Fhu")),
            large: ()=>(parcelRequire("2EQdA"))
        },
        [(0, $8dVIb.IconType).Problem]: {
            default: ()=>(parcelRequire("3Qygt")),
            large: ()=>(parcelRequire("7GCAt"))
        },
        [(0, $8dVIb.IconType).ServiceRequest]: {
            default: ()=>(parcelRequire("7J5Ma")),
            large: ()=>(parcelRequire("akYbd"))
        },
        [(0, $8dVIb.IconType).Story]: {
            default: ()=>(parcelRequire("iErKi")),
            large: ()=>(parcelRequire("fuaYA"))
        },
        [(0, $8dVIb.IconType).SubTask]: {
            default: ()=>(parcelRequire("kBegL")),
            large: ()=>(parcelRequire("5sJWF"))
        },
        [(0, $8dVIb.IconType).Task]: {
            default: ()=>(parcelRequire("dqT3O")),
            large: ()=>(parcelRequire("gQ4Nj"))
        },
        // Confluence icons
        [(0, $8dVIb.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("4Atwu"))),
            large: ()=>Promise.resolve((parcelRequire("8lQ8Y")))
        },
        // Provider icons
        [(0, $8dVIb.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $8dVIb.IconType).Jira]: {
            default: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $8dVIb.IconType).Attachment]: {
            default: ()=>(parcelRequire("fkmri"))
        },
        [(0, $8dVIb.IconType).CheckItem]: {
            default: ()=>(parcelRequire("eU0GA"))
        },
        [(0, $8dVIb.IconType).Comment]: {
            default: ()=>(parcelRequire("jAQ3K"))
        },
        [(0, $8dVIb.IconType).View]: {
            default: ()=>(parcelRequire("8YU6y"))
        },
        [(0, $8dVIb.IconType).React]: {
            default: ()=>(parcelRequire("7nuvV"))
        },
        [(0, $8dVIb.IconType).Vote]: {
            default: ()=>(parcelRequire("hFsYk"))
        },
        [(0, $8dVIb.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("gMDFI"))
        },
        [(0, $8dVIb.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("4fkVg"))
        },
        [(0, $8dVIb.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("fgN6p"))
        },
        [(0, $8dVIb.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("cV2N9"))
        },
        [(0, $8dVIb.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("eVavM"))
        },
        [(0, $8dVIb.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("56RVo"))
        },
        [(0, $8dVIb.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("ktXnL"))
        },
        [(0, $8dVIb.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("9mM5H"))
        },
        [(0, $8dVIb.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("1O0Re"))
        },
        [(0, $8dVIb.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("lGGho"))
        },
        [(0, $8dVIb.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("2LtoJ"))
        },
        [(0, $8dVIb.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("lE2nX"))
        },
        [(0, $8dVIb.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("4hqZ5")))
        },
        [(0, $8dVIb.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("dWKdk"))
        }
    };
};
const $c53851cced73411d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $liAf6.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $c53851cced73411d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $c53851cced73411d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $c53851cced73411d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $c53851cced73411d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $c53851cced73411d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $c53851cced73411d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $c53851cced73411d$export$e772c8ff12451969(interval);
            return $c53851cced73411d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $c53851cced73411d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $c53851cced73411d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $c53851cced73411d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $imVhc.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $c53851cced73411d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $8dVIb.SmartLinkSize).Large,
        (0, $8dVIb.SmartLinkSize).XLarge
    ].includes(size);

});
parcelRegister("8dVIb", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $ad6fd5c2f706e309$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $ad6fd5c2f706e309$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $ad6fd5c2f706e309$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $ad6fd5c2f706e309$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $ad6fd5c2f706e309$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $ad6fd5c2f706e309$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $ad6fd5c2f706e309$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $ad6fd5c2f706e309$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $ad6fd5c2f706e309$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $ad6fd5c2f706e309$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $ad6fd5c2f706e309$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $ad6fd5c2f706e309$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $ad6fd5c2f706e309$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $ad6fd5c2f706e309$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $ad6fd5c2f706e309$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $ad6fd5c2f706e309$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $ad6fd5c2f706e309$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $ad6fd5c2f706e309$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804);
const $ad6fd5c2f706e309$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $ad6fd5c2f706e309$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $ad6fd5c2f706e309$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $ad6fd5c2f706e309$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $ad6fd5c2f706e309$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $ad6fd5c2f706e309$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $ad6fd5c2f706e309$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $ad6fd5c2f706e309$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $ad6fd5c2f706e309$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $ad6fd5c2f706e309$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $ad6fd5c2f706e309$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $ad6fd5c2f706e309$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $ad6fd5c2f706e309$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $ad6fd5c2f706e309$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $ad6fd5c2f706e309$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $ad6fd5c2f706e309$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $ad6fd5c2f706e309$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $ad6fd5c2f706e309$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("liAf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67e22f2f57cb4a6$export$2e2bcd8739ae039);

var $8dVIb = parcelRequire("8dVIb");
const $d67e22f2f57cb4a6$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $8dVIb.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $8dVIb.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $8dVIb.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $8dVIb.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $8dVIb.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $8dVIb.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $8dVIb.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $8dVIb.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $8dVIb.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $8dVIb.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $8dVIb.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $8dVIb.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $8dVIb.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $8dVIb.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $8dVIb.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $8dVIb.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $8dVIb.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $8dVIb.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $8dVIb.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $d67e22f2f57cb4a6$export$2e2bcd8739ae039 = $d67e22f2f57cb4a6$var$extractFileFormatIcon;

});

parcelRegister("duwKf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9d277a30a5a98acd$var$_react = $9d277a30a5a98acd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9d277a30a5a98acd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d277a30a5a98acd$var$Document16Icon = (props)=>/*#__PURE__*/ $9d277a30a5a98acd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$9d277a30a5a98acd$var$Document16Icon.displayName = 'Document16Icon';
var $9d277a30a5a98acd$var$_default = module.exports.default = $9d277a30a5a98acd$var$Document16Icon;

});

parcelRegister("6q8Pr", function(module, exports) {

let $4acc04fa6828837e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4acc04fa6828837e$var$load("7EgS6").then(()=>parcelRequire('3KifV'));

});

parcelRegister("e3PhT", function(module, exports) {

let $a3c92121ff44871f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a3c92121ff44871f$var$load("erQ4S").then(()=>parcelRequire('im5Hg'));

});

parcelRegister("55TA3", function(module, exports) {

let $3b5888855c97ba42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b5888855c97ba42$var$load("d767x").then(()=>parcelRequire('5m93C'));

});

parcelRegister("lb4t9", function(module, exports) {

let $f6ae178ddd88f3b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f6ae178ddd88f3b4$var$load("lQ9xE").then(()=>parcelRequire('2Bgv8'));

});

parcelRegister("bwXIZ", function(module, exports) {

let $865102f672a4212f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $865102f672a4212f$var$load("izomc").then(()=>parcelRequire('iByEQ'));

});

parcelRegister("8vv4H", function(module, exports) {

let $631952ccff1c149a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $631952ccff1c149a$var$load("5I4RC").then(()=>parcelRequire('eABwY'));

});

parcelRegister("2t9Hh", function(module, exports) {

let $1cc5cfd630a69c27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1cc5cfd630a69c27$var$load("iV5W6").then(()=>parcelRequire('h7zk4'));

});

parcelRegister("6SoQO", function(module, exports) {

let $501b100cfa76ff8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $501b100cfa76ff8e$var$load("jepjM").then(()=>parcelRequire('F35X1'));

});

parcelRegister("TZHl8", function(module, exports) {

let $0a84ff1cb84378c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a84ff1cb84378c5$var$load("3YI2r").then(()=>parcelRequire('kKp2J'));

});

parcelRegister("3VL73", function(module, exports) {

let $2dcb3d9afd9c957a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2dcb3d9afd9c957a$var$load("cwkUf").then(()=>parcelRequire('j8IiS'));

});

parcelRegister("ifmtc", function(module, exports) {

let $d48b0ecc93ef9e55$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d48b0ecc93ef9e55$var$load("hVGrh").then(()=>parcelRequire('daL8e'));

});

parcelRegister("eogSM", function(module, exports) {

let $a7a0671937c9e1f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a7a0671937c9e1f3$var$load("aAton").then(()=>parcelRequire('96Idm'));

});

parcelRegister("5nV2R", function(module, exports) {

let $3ebb59b9b44ae7f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ebb59b9b44ae7f7$var$load("iDnD4").then(()=>parcelRequire('dOkKo'));

});

parcelRegister("6Y2WT", function(module, exports) {

let $512aa2425db43ab6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $512aa2425db43ab6$var$load("dhQt8").then(()=>parcelRequire('lDRqn'));

});

parcelRegister("4m4MY", function(module, exports) {

let $32bcee7caa856311$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32bcee7caa856311$var$load("7QDLp").then(()=>parcelRequire('8njZH'));

});

parcelRegister("gmDdF", function(module, exports) {

let $be9d1f90638c1db6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be9d1f90638c1db6$var$load("b2yZA").then(()=>parcelRequire('lp0fk'));

});

parcelRegister("coOzc", function(module, exports) {

let $906ef36933b15f5b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $906ef36933b15f5b$var$load("5khw4").then(()=>parcelRequire('6cEsd'));

});

parcelRegister("ldQLy", function(module, exports) {

let $f733be138af3b35d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f733be138af3b35d$var$load("c1Yqk").then(()=>parcelRequire('7BHMh'));

});

parcelRegister("4WgJk", function(module, exports) {

let $39898e76c9d3a3c2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39898e76c9d3a3c2$var$load("a5lMy").then(()=>parcelRequire('lE6mu'));

});

parcelRegister("fjtI4", function(module, exports) {

let $b25fad1f7947bb8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b25fad1f7947bb8b$var$load("gaqBx").then(()=>parcelRequire('bBHpS'));

});

parcelRegister("94rku", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $56fb369bc3845a35$export$2e2bcd8739ae039);

var $duwKf = parcelRequire("duwKf");

var $kdfZa = parcelRequire("kdfZa");

var $50H21 = parcelRequire("50H21");
const $56fb369bc3845a35$var$PageIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), 'blueBold', (0, (/*@__PURE__*/$parcel$interopDefault($duwKf))));
$56fb369bc3845a35$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $56fb369bc3845a35$export$2e2bcd8739ae039 = $56fb369bc3845a35$var$PageIconWithColor;

});
parcelRegister("50H21", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $399bb260cc38f0bb$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $399bb260cc38f0bb$export$87c3646d0e299cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");
const $399bb260cc38f0bb$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $399bb260cc38f0bb$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $kxcRq.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $2OMIu.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(IconSmall, {
            ...props
        });
    };
};
const $399bb260cc38f0bb$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
            appearance: appearance,
            icon: Icon,
            size: $399bb260cc38f0bb$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $2OMIu.jsx)(LegacyIcon, {
                ...props
            })
        });
    };
};

});
parcelRegister("cwmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a921419639fe8f6f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $a921419639fe8f6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a921419639fe8f6f$var$sizeMap = {
    '16': {
        name: "157xhr7",
        styles: "width:16px;height:16px"
    },
    '24': {
        name: "rrel8y",
        styles: "width:24px;height:24px"
    },
    '32': {
        name: "68x97p",
        styles: "width:32px;height:32px"
    },
    '40': {
        name: "1mfsro6",
        styles: "width:40px;height:40px"
    },
    '48': {
        name: "18jhpep",
        styles: "width:48px;height:48px"
    }
};
const $a921419639fe8f6f$var$appearanceMap = {
    grayBold: {
        name: "algye9",
        styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    limeBold: {
        name: "a86nvv",
        styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    greenBold: {
        name: "13e2qqr",
        styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    blueBold: {
        name: "jpsdma",
        styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    redBold: {
        name: "1bg8y7a",
        styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    purpleBold: {
        name: "19bo3lb",
        styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    magentaBold: {
        name: "1l16rgo",
        styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    tealBold: {
        name: "7kw5zl",
        styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    orangeBold: {
        name: "h77eay",
        styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    yellowBold: {
        name: "sbe4w3",
        styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    gray: {
        name: "yxgei8",
        styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
    },
    lime: {
        name: "o9c6oh",
        styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
    },
    orange: {
        name: "szqzk5",
        styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
    },
    magenta: {
        name: "o6ptuw",
        styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
    },
    green: {
        name: "157dg7e",
        styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
    },
    blue: {
        name: "x3nujl",
        styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
    },
    red: {
        name: "zqoyws",
        styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
    },
    purple: {
        name: "fitjkd",
        styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
    },
    teal: {
        name: "b3m1ww",
        styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
    },
    yellow: {
        name: "1j18jub",
        styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
    }
};
const $a921419639fe8f6f$var$shapeMap = {
    square: {
        name: "vwdoqr",
        styles: "border-radius:var(--ds-border-radius-100, 4px)"
    },
    circle: {
        name: "i2ucdk",
        styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
    }
};
const $a921419639fe8f6f$var$iconTileStyles = {
    name: "1ot07ws",
    styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;font-size:0"
};
function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    if (LEGACY_fallbackComponent && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-testid": testId,
        css: [
            $a921419639fe8f6f$var$iconTileStyles,
            $a921419639fe8f6f$var$appearanceMap[appearance],
            $a921419639fe8f6f$var$sizeMap[size],
            $a921419639fe8f6f$var$shapeMap[shape]
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(ExpandedIcon, {
        color: "currentColor",
        label: label,
        spacing: "spacious",
        shouldScale: true
    }));
}

});



parcelRegister("dVpJZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5e665de7fe478f98$export$2e2bcd8739ae039);

var $iRZQl = parcelRequire("iRZQl");

var $7oCpB = parcelRequire("7oCpB");

var $50H21 = parcelRequire("50H21");
const $5e665de7fe478f98$var$BlogIconWithColor = (0, $50H21.renderIconPerSize)((0, $iRZQl.default), (0, $7oCpB.default));
$5e665de7fe478f98$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $5e665de7fe478f98$export$2e2bcd8739ae039 = $5e665de7fe478f98$var$BlogIconWithColor;

});
parcelRegister("iRZQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $24299d4e22463111$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845767e81b63ae055da0ba81295847f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $hZgcq = parcelRequire("hZgcq");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $24299d4e22463111$var$Blog16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
        label: label,
        testId: testId
    });
};
$24299d4e22463111$var$Blog16Icon.displayName = 'Blog16Icon';
var $24299d4e22463111$export$2e2bcd8739ae039 = $24299d4e22463111$var$Blog16Icon;

});
parcelRegister("2UiHO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21df524c58bafc58$var$_react = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21df524c58bafc58$var$_baseNew = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $21df524c58bafc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21df524c58bafc58$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $21df524c58bafc58$var$_react.default.createElement($21df524c58bafc58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$21df524c58bafc58$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $21df524c58bafc58$var$_default = module.exports.default = $21df524c58bafc58$var$QuotationMarkIcon;

});

parcelRegister("hZgcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $47749dc4aba4294e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $47749dc4aba4294e$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$47749dc4aba4294e$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$47749dc4aba4294e$export$2e2bcd8739ae039 = $47749dc4aba4294e$var$Blog16Icon;

});


parcelRegister("7oCpB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8806751d7f7ea905$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bba35c7457f1c82d9d31626969c259a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $asoCt = parcelRequire("asoCt");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $8806751d7f7ea905$var$Blog24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asoCt.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asoCt.default), {
        label: label,
        testId: testId
    });
};
$8806751d7f7ea905$var$Blog24Icon.displayName = 'Blog24Icon';
var $8806751d7f7ea905$export$2e2bcd8739ae039 = $8806751d7f7ea905$var$Blog24Icon;

});
parcelRegister("asoCt", function(module, exports) {

$parcel$export(module.exports, "default", () => $158d85a5273c8dbb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7682b4d34bd2a783038ec83f3b47a94>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $158d85a5273c8dbb$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$158d85a5273c8dbb$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$158d85a5273c8dbb$export$2e2bcd8739ae039 = $158d85a5273c8dbb$var$Blog24Icon;

});



parcelRegister("6ftoN", function(module, exports) {

let $48caf2cb3a2b031c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48caf2cb3a2b031c$var$load("4AlWm").then(()=>parcelRequire('aQnRv'));

});

parcelRegister("a0Blm", function(module, exports) {

let $7496df20f241cc20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7496df20f241cc20$var$load("1oL5z").then(()=>parcelRequire('3WUNe'));

});

parcelRegister("gp1iV", function(module, exports) {

let $bf0ffe1d32436e05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bf0ffe1d32436e05$var$load("dBvdI").then(()=>parcelRequire('3vtQf'));

});

parcelRegister("jJcF3", function(module, exports) {

let $e5cc0a8e109344ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e5cc0a8e109344ba$var$load("h2MrD"),
    $e5cc0a8e109344ba$var$load("bYT2S"),
    $e5cc0a8e109344ba$var$load("947Ze")
]).then(()=>parcelRequire('ikced'));

});

parcelRegister("eT6gz", function(module, exports) {

let $ad6b101988e539b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad6b101988e539b4$var$load("9Rmva").then(()=>parcelRequire('aRGuz'));

});

parcelRegister("fHKiX", function(module, exports) {

let $b6eeca4f456dab34$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6eeca4f456dab34$var$load("4iYn6").then(()=>parcelRequire('gVXQp'));

});

parcelRegister("2UVok", function(module, exports) {

let $21fd547d8bca657c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $21fd547d8bca657c$var$load("h2MrD"),
    $21fd547d8bca657c$var$load("bYT2S"),
    $21fd547d8bca657c$var$load("7tpZr")
]).then(()=>parcelRequire('9bx9i'));

});

parcelRegister("3K7kY", function(module, exports) {

let $2b9b5c0158d75df8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2b9b5c0158d75df8$var$load("4OyEJ").then(()=>parcelRequire('T5PvZ'));

});

parcelRegister("vxJ9s", function(module, exports) {

let $05ed0ee4e8760d18$var$load = (parcelRequire("28QjX"))(4);
module.exports = $05ed0ee4e8760d18$var$load("a98CY").then(()=>parcelRequire('5mR3i'));

});

parcelRegister("23MsP", function(module, exports) {

let $180174885bfd768b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $180174885bfd768b$var$load("b4dsH").then(()=>parcelRequire('a8hd9'));

});

parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});


parcelRegister("6jkTx", function(module, exports) {

let $4984b9ac5dd985b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4984b9ac5dd985b2$var$load("9HbdP").then(()=>parcelRequire('9CRO6'));

});

parcelRegister("kWjiJ", function(module, exports) {

let $f3e832343a860d40$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f3e832343a860d40$var$load("dhNrp").then(()=>parcelRequire('dGYEZ'));

});

parcelRegister("03kpR", function(module, exports) {

let $00a01e23806922fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00a01e23806922fc$var$load("kqcH1").then(()=>parcelRequire('RiK2l'));

});

parcelRegister("3rJ38", function(module, exports) {

let $2826d69fb4be605d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2826d69fb4be605d$var$load("lJtIM").then(()=>parcelRequire('iBOon'));

});

parcelRegister("jiAjo", function(module, exports) {

let $e0cbdd8613b70fc8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0cbdd8613b70fc8$var$load("5dt09").then(()=>parcelRequire('jdlqN'));

});

parcelRegister("3hQB1", function(module, exports) {

let $264bc21b80cc2a91$var$load = (parcelRequire("28QjX"))(4);
module.exports = $264bc21b80cc2a91$var$load("3WmO0").then(()=>parcelRequire('c70Lr'));

});

parcelRegister("70xas", function(module, exports) {

let $51a242e0c91d3734$var$load = (parcelRequire("28QjX"))(4);
module.exports = $51a242e0c91d3734$var$load("iSSEO").then(()=>parcelRequire('2osAJ'));

});

parcelRegister("7P2U4", function(module, exports) {

let $5b1f8c62c8f11a51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5b1f8c62c8f11a51$var$load("9ykhE").then(()=>parcelRequire('7zjHG'));

});

parcelRegister("9Eo4X", function(module, exports) {

let $706a870b80e487e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $706a870b80e487e0$var$load("ejGmj").then(()=>parcelRequire('cHwqN'));

});

parcelRegister("gBnqE", function(module, exports) {

let $c16246890c5b74cb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c16246890c5b74cb$var$load("5zjWD").then(()=>parcelRequire('2sfBf'));

});

parcelRegister("eWGoe", function(module, exports) {

let $ae175d383ef4ff8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ae175d383ef4ff8e$var$load("fGPpk").then(()=>parcelRequire('2tm8x'));

});

parcelRegister("fu8cn", function(module, exports) {

let $b460046dacf40544$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b460046dacf40544$var$load("4Ckra").then(()=>parcelRequire('iABw2'));

});

parcelRegister("cAU6j", function(module, exports) {

let $92b45d4aa046f329$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92b45d4aa046f329$var$load("evpxF").then(()=>parcelRequire('4sBeG'));

});

parcelRegister("4rggH", function(module, exports) {

let $33b64d92455eac54$var$load = (parcelRequire("28QjX"))(4);
module.exports = $33b64d92455eac54$var$load("g985s").then(()=>parcelRequire('l04jD'));

});

parcelRegister("bn2CC", function(module, exports) {

let $8473e052ffb4388d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8473e052ffb4388d$var$load("kAF19").then(()=>parcelRequire('bPjbr'));

});

parcelRegister("2nXLN", function(module, exports) {

let $1bcc17d3fb7fe2fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1bcc17d3fb7fe2fd$var$load("16ic3").then(()=>parcelRequire('52A0r'));

});

parcelRegister("cIR4U", function(module, exports) {

let $9432c454ef92166f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9432c454ef92166f$var$load("7R5g7").then(()=>parcelRequire('6qWjs'));

});

parcelRegister("d4Msz", function(module, exports) {

let $98513d3325793783$var$load = (parcelRequire("28QjX"))(4);
module.exports = $98513d3325793783$var$load("gvHhR").then(()=>parcelRequire('c9Fqq'));

});

parcelRegister("bbgWK", function(module, exports) {

let $823dde017897a8a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $823dde017897a8a8$var$load("6TtDJ").then(()=>parcelRequire('ezu4w'));

});

parcelRegister("4Z42j", function(module, exports) {

let $3a0ffd720a4a477e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a0ffd720a4a477e$var$load("1NHTB").then(()=>parcelRequire('6OpPE'));

});

parcelRegister("jNgVH", function(module, exports) {

let $e68fb9c58ac59414$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e68fb9c58ac59414$var$load("kgx4U").then(()=>parcelRequire('iAkpb'));

});

parcelRegister("9LCHw", function(module, exports) {

let $71c6860eabfcf304$var$load = (parcelRequire("28QjX"))(4);
module.exports = $71c6860eabfcf304$var$load("9PpGe").then(()=>parcelRequire('41M8N'));

});

parcelRegister("hhL96", function(module, exports) {

let $c958985d73c1112b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c958985d73c1112b$var$load("eSwNo").then(()=>parcelRequire('jnURg'));

});

parcelRegister("tyrb0", function(module, exports) {

let $058d6c15a4a2e74c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $058d6c15a4a2e74c$var$load("bSBaJ").then(()=>parcelRequire('4MX1d'));

});

parcelRegister("9q15g", function(module, exports) {

let $6db76207028d4cfd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6db76207028d4cfd$var$load("cUQWc").then(()=>parcelRequire('gAdQO'));

});

parcelRegister("fwsJh", function(module, exports) {

let $b4d021375f2ba907$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4d021375f2ba907$var$load("3w7tM").then(()=>parcelRequire('eHc1t'));

});

parcelRegister("14Fhu", function(module, exports) {

let $0c862fbc2ccb568d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c862fbc2ccb568d$var$load("j373d").then(()=>parcelRequire('6ClRv'));

});

parcelRegister("2EQdA", function(module, exports) {

let $1ef7d29d585441a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1ef7d29d585441a3$var$load("hdkrH").then(()=>parcelRequire('529Ow'));

});

parcelRegister("3Qygt", function(module, exports) {

let $2cd0ceaab7b162da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2cd0ceaab7b162da$var$load("9HJjr").then(()=>parcelRequire('1ni2E'));

});

parcelRegister("7GCAt", function(module, exports) {

let $598a634b3bebd565$var$load = (parcelRequire("28QjX"))(4);
module.exports = $598a634b3bebd565$var$load("fcEu0").then(()=>parcelRequire('gaBfD'));

});

parcelRegister("7J5Ma", function(module, exports) {

let $5a013757451c6962$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a013757451c6962$var$load("jXTSM").then(()=>parcelRequire('kQSMP'));

});

parcelRegister("akYbd", function(module, exports) {

let $786a741696fc3955$var$load = (parcelRequire("28QjX"))(4);
module.exports = $786a741696fc3955$var$load("2nFSk").then(()=>parcelRequire('36Q2c'));

});

parcelRegister("iErKi", function(module, exports) {

let $d9417c2310d04e80$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d9417c2310d04e80$var$load("hU82q").then(()=>parcelRequire('kvhCa'));

});

parcelRegister("fuaYA", function(module, exports) {

let $b4622c006adc733a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4622c006adc733a$var$load("cVndS").then(()=>parcelRequire('21nCU'));

});

parcelRegister("kBegL", function(module, exports) {

let $eff254ee4c0946e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eff254ee4c0946e8$var$load("3YoR7").then(()=>parcelRequire('dvo9I'));

});

parcelRegister("5sJWF", function(module, exports) {

let $3fa33507f5ae198f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3fa33507f5ae198f$var$load("hYBCI").then(()=>parcelRequire('93zHH'));

});

parcelRegister("dqT3O", function(module, exports) {

let $9c7869f611584426$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9c7869f611584426$var$load("3dBSm").then(()=>parcelRequire('ercGv'));

});

parcelRegister("gQ4Nj", function(module, exports) {

let $c42538c02c4bc2c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c42538c02c4bc2c7$var$load("bG6hF").then(()=>parcelRequire('eFWxr'));

});

parcelRegister("4Atwu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67f5211f96bd858e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1228c9bdd9840505938b56c7ed44212>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2OgES = parcelRequire("2OgES");

var $VSDnB = parcelRequire("VSDnB");

var $i0wCi = parcelRequire("i0wCi");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67f5211f96bd858e$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OgES))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
        label: label,
        testId: testId
    });
};
$67f5211f96bd858e$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $67f5211f96bd858e$export$2e2bcd8739ae039 = $67f5211f96bd858e$var$PageLiveDoc16Icon;

});
parcelRegister("2OgES", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::692b62fec4c56cd82ae8d8d02e2d3f2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20bd2c4c7f421719$var$_react = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $20bd2c4c7f421719$var$_baseNew = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $20bd2c4c7f421719$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20bd2c4c7f421719$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $20bd2c4c7f421719$var$_react.default.createElement($20bd2c4c7f421719$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$20bd2c4c7f421719$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $20bd2c4c7f421719$var$_default = module.exports.default = $20bd2c4c7f421719$var$PageLiveDocIcon;

});

parcelRegister("i0wCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e01b6db3f29618ed$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbb561a99c36d24f949f1ade9ed1fa72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $e01b6db3f29618ed$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$e01b6db3f29618ed$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e01b6db3f29618ed$export$2e2bcd8739ae039 = $e01b6db3f29618ed$var$PageLiveDoc16Icon;

});


parcelRegister("8lQ8Y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $40d9c5b900864dd9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::724c9bd5f0d44d16613664f162286445>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2OgES = parcelRequire("2OgES");

var $VSDnB = parcelRequire("VSDnB");

var $25dv3 = parcelRequire("25dv3");
/**
 * __24px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $40d9c5b900864dd9$var$PageLiveDoc24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OgES))),
        appearance: "magentaBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $25dv3.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $25dv3.default), {
        label: label,
        testId: testId
    });
};
$40d9c5b900864dd9$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var $40d9c5b900864dd9$export$2e2bcd8739ae039 = $40d9c5b900864dd9$var$PageLiveDoc24Icon;

});
parcelRegister("25dv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b5ea63b1e20da2$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5906433494daa938e0cf018edb0a9fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $23b5ea63b1e20da2$var$PageLiveDoc24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m10.555-6.832a1 1 0 0 0-1.545.973l1 7a1 1 0 0 0 1.884.306L17.118 17H20a1 1 0 0 0 .555-1.832z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "medium"
    });
$23b5ea63b1e20da2$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$23b5ea63b1e20da2$export$2e2bcd8739ae039 = $23b5ea63b1e20da2$var$PageLiveDoc24Icon;

});


parcelRegister("fkmri", function(module, exports) {

let $b28a214429ff684e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b28a214429ff684e$var$load("4JCpI").then(()=>parcelRequire('eZ9Cp'));

});

parcelRegister("eU0GA", function(module, exports) {

let $ad96d3dfca5d31e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad96d3dfca5d31e6$var$load("cEm5a").then(()=>parcelRequire('f5h6d'));

});

parcelRegister("jAQ3K", function(module, exports) {

let $e439c306ecaf2b13$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e439c306ecaf2b13$var$load("jfejx").then(()=>parcelRequire('729P0'));

});

parcelRegister("8YU6y", function(module, exports) {

let $689f728ade92de82$var$load = (parcelRequire("28QjX"))(4);
module.exports = $689f728ade92de82$var$load("4GgiA").then(()=>parcelRequire('6N55R'));

});

parcelRegister("7nuvV", function(module, exports) {

let $55f259d0aa4b0aae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $55f259d0aa4b0aae$var$load("5xN5V").then(()=>parcelRequire('3xPiH'));

});

parcelRegister("hFsYk", function(module, exports) {

let $cdccbd4229e64354$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cdccbd4229e64354$var$load("fRQeP").then(()=>parcelRequire('9j532'));

});

parcelRegister("gMDFI", function(module, exports) {

let $c37fe70f109b78ee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c37fe70f109b78ee$var$load("2JrEQ").then(()=>parcelRequire('jJL9z'));

});

parcelRegister("4fkVg", function(module, exports) {

let $3178caf18816bb57$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3178caf18816bb57$var$load("czPXX").then(()=>parcelRequire('3pKEh'));

});

parcelRegister("fgN6p", function(module, exports) {

let $b1de7052f50bfcad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b1de7052f50bfcad$var$load("bW2Ht").then(()=>parcelRequire('k7gBp'));

});

parcelRegister("cV2N9", function(module, exports) {

let $967cf94be8e9a9d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $967cf94be8e9a9d5$var$load("jlDVs").then(()=>parcelRequire('Le10t'));

});

parcelRegister("eVavM", function(module, exports) {

let $adce8af64095102c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $adce8af64095102c$var$load("9n8Rc").then(()=>parcelRequire('kc1MS'));

});

parcelRegister("56RVo", function(module, exports) {

let $3b87579a8c1c9c89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b87579a8c1c9c89$var$load("a0ALI").then(()=>parcelRequire('hfn9j'));

});

parcelRegister("ktXnL", function(module, exports) {

let $ee94942a5dcf51e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee94942a5dcf51e4$var$load("kFjg9").then(()=>parcelRequire('4zl0K'));

});

parcelRegister("9mM5H", function(module, exports) {

let $6d1b79007a44e718$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d1b79007a44e718$var$load("50gXn").then(()=>parcelRequire('cfbO3'));

});

parcelRegister("1O0Re", function(module, exports) {

let $150b203f6494e0b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $150b203f6494e0b7$var$load("1Bya1").then(()=>parcelRequire('jyFo7'));

});

parcelRegister("lGGho", function(module, exports) {

let $fc9e510f6e16a672$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc9e510f6e16a672$var$load("6xK7c").then(()=>parcelRequire('eJNZM'));

});

parcelRegister("2LtoJ", function(module, exports) {

let $2036c66122d65aa9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2036c66122d65aa9$var$load("h2MrD"),
    $2036c66122d65aa9$var$load("bYT2S"),
    $2036c66122d65aa9$var$load("2ZGIQ")
]).then(()=>parcelRequire('2CRmv'));

});

parcelRegister("lE2nX", function(module, exports) {

let $fc1f2f1d241904fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc1f2f1d241904fb$var$load("kXqCi").then(()=>parcelRequire('2ciBJ'));

});

parcelRegister("dWKdk", function(module, exports) {

let $a2748a45fd722a7d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2748a45fd722a7d$var$load("gPQs2").then(()=>parcelRequire('2lRM4'));

});


parcelRegister("5igsJ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$eaff10f7ec59c455);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $ffYTp = parcelRequire("ffYTp");

var $051X7 = parcelRequire("051X7");

var $cCcdH = parcelRequire("cCcdH");

var $VSDnB = parcelRequire("VSDnB");

var $hjhAz = parcelRequire("hjhAz");

var $fzJZi = parcelRequire("fzJZi");
const $31931ec4ffeaf53a$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $ffYTp.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $31931ec4ffeaf53a$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $fzJZi.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $31931ec4ffeaf53a$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const state = store ? (0, $cCcdH.getUrl)(store, url) : undefined;
    return (0, $5uXOq.useMemo)(()=>{
        return $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $31931ec4ffeaf53a$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $hjhAz.useSmartCardState)(url);
    const data = $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $VSDnB.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("ffYTp", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $842bbc6d3f3b5d59$export$7243431f5325a7b);

var $fiKQs = parcelRequire("fiKQs");

var $iHcpV = parcelRequire("iHcpV");

var $VSDnB = parcelRequire("VSDnB");
const $842bbc6d3f3b5d59$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $fiKQs.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $iHcpV.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $VSDnB.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("iHcpV", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $1a9daeca9ad503b7$export$28ddbae335bd80b5);
const $1a9daeca9ad503b7$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});


parcelRegister("hjhAz", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $7fb324870ee27912$export$b0444d00ba7313c6);

var $bDWQ3 = parcelRequire("bDWQ3");

var $051X7 = parcelRequire("051X7");
const $7fb324870ee27912$var$PENDING_STATE = {
    status: 'pending'
};
function $7fb324870ee27912$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const cardState = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $7fb324870ee27912$var$PENDING_STATE;
}

});


parcelRegister("91tw3", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $f30ba994fabdf720$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $f30ba994fabdf720$export$df0092b19156b140);
$parcel$export(module.exports, "isStyleCacheProvider", () => $f30ba994fabdf720$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $f30ba994fabdf720$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $f30ba994fabdf720$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $f30ba994fabdf720$export$c0547b4405cae584);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $66ZRy = parcelRequire("66ZRy");
var $buvhv = parcelRequire("buvhv");
var $hYQw7 = parcelRequire("hYQw7");
var $ietxm = parcelRequire("ietxm");

var $eqoQu = parcelRequire("eqoQu");
const $f30ba994fabdf720$export$3c94e0f4719f5c2a = (children, ui)=>{
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-openness')) {
        if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)?.length > 0 ? true : false;
    }
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).some((child)=>$f30ba994fabdf720$export$df0092b19156b140(child))) return true;
    return false;
};
const $f30ba994fabdf720$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $f30ba994fabdf720$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($66ZRy).some((type)=>type === node.type)) return true;
    return false;
};
const $f30ba994fabdf720$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (Object.values($eqoQu).some((type)=>type === node.type)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $buvhv.default)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $hYQw7.default)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $ietxm.default);

});
parcelRegister("66ZRy", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("ietxm")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gg6Qm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("hYQw7")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("1JaZ4")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("buvhv")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("dghu0")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("5HrTg")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("1qDIM")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("85ffk")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("fh9qw")).default);

var $ietxm = parcelRequire("ietxm");

var $gg6Qm = parcelRequire("gg6Qm");

var $hYQw7 = parcelRequire("hYQw7");

var $1JaZ4 = parcelRequire("1JaZ4");

var $buvhv = parcelRequire("buvhv");

var $dghu0 = parcelRequire("dghu0");

var $5HrTg = parcelRequire("5HrTg");

var $1qDIM = parcelRequire("1qDIM");

var $85ffk = parcelRequire("85ffk");

var $fh9qw = parcelRequire("fh9qw");

});
parcelRegister("ietxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fcebb5ad9978d90$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $5HrTg = parcelRequire("5HrTg");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $3fcebb5ad9978d90$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HrTg.default), {
        ...props,
        testId: testId
    });
};
var $3fcebb5ad9978d90$export$2e2bcd8739ae039 = $3fcebb5ad9978d90$var$FooterBlock;

});
parcelRegister("5HrTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8eaafd3e75b73f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $b8eaafd3e75b73f4$var$actionGroupStylesOld = null;
const $b8eaafd3e75b73f4$var$actionGroupStyles = null;
const $b8eaafd3e75b73f4$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $8dVIb.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const hasActions = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                testId: "smart-element-group-actions",
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {
                    css: size === (0, $8dVIb.SmartLinkSize).XLarge && $b8eaafd3e75b73f4$var$actionGroupStyles
                } : {
                    css: size === (0, $8dVIb.SmartLinkSize).XLarge && $b8eaafd3e75b73f4$var$actionGroupStylesOld
                },
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $b8eaafd3e75b73f4$export$2e2bcd8739ae039 = $b8eaafd3e75b73f4$var$FooterBlockResolvedView;

});
parcelRegister("Nh1XU", function(module, exports) {

$parcel$export(module.exports, "FlexibleUiContext", () => $79a38154bf117346$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $79a38154bf117346$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $79a38154bf117346$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $79a38154bf117346$export$e6b5ad18b56e8f51);

var $5uXOq = parcelRequire("5uXOq");
const $79a38154bf117346$export$ca70b164b615de47 = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$61d7957a243df7aa = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$ca70b164b615de47);
const $79a38154bf117346$export$f7433dbd6c50e26a = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$e6b5ad18b56e8f51 = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$f7433dbd6c50e26a);

});

parcelRegister("eqoQu", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $ec376f2b71614cc0$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $ec376f2b71614cc0$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $ec376f2b71614cc0$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $ec376f2b71614cc0$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $ec376f2b71614cc0$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $ec376f2b71614cc0$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $ec376f2b71614cc0$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $ec376f2b71614cc0$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $ec376f2b71614cc0$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $ec376f2b71614cc0$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $ec376f2b71614cc0$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $ec376f2b71614cc0$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $ec376f2b71614cc0$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $ec376f2b71614cc0$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $ec376f2b71614cc0$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $ec376f2b71614cc0$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $ec376f2b71614cc0$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $ec376f2b71614cc0$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $ec376f2b71614cc0$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $ec376f2b71614cc0$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $ec376f2b71614cc0$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $ec376f2b71614cc0$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $ec376f2b71614cc0$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $ec376f2b71614cc0$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $ec376f2b71614cc0$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $ec376f2b71614cc0$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $ec376f2b71614cc0$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $ec376f2b71614cc0$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $ec376f2b71614cc0$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $ec376f2b71614cc0$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $ec376f2b71614cc0$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $ec376f2b71614cc0$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("kDhrr")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("kp8aU")).default);

var $8dVIb = parcelRequire("8dVIb");

var $eCsaJ = parcelRequire("eCsaJ");

var $kDhrr = parcelRequire("kDhrr");

var $kp8aU = parcelRequire("kp8aU");
const $ec376f2b71614cc0$export$d3af56c23f9e459b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedTo);
const $ec376f2b71614cc0$export$fbd18f11bf3a3444 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedToGroup);
const $ec376f2b71614cc0$export$3bc3c9693a40aa = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AttachmentCount);
const $ec376f2b71614cc0$export$2ae2af4435dd6144 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AuthorGroup);
const $ec376f2b71614cc0$export$5742b38fd5cfe410 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ChecklistProgress);
const $ec376f2b71614cc0$export$a1e647014985ddb9 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CollaboratorGroup);
const $ec376f2b71614cc0$export$f4c1466e6fdd07b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CommentCount);
const $ec376f2b71614cc0$export$53ced9403d373871 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedOn);
const $ec376f2b71614cc0$export$db468caedefbb630 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedBy);
const $ec376f2b71614cc0$export$fea59459cfa1625b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).DueOn);
const $ec376f2b71614cc0$export$2aa8c58ab6c8ae64 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LatestCommit);
const $ec376f2b71614cc0$export$69387b41dfc808f7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LinkIcon);
const $ec376f2b71614cc0$export$18a2be9195644f38 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Location);
const $ec376f2b71614cc0$export$ebbbdcc68d717b7b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedBy);
const $ec376f2b71614cc0$export$a6db3f4240728b58 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedOn);
const $ec376f2b71614cc0$export$fa04b1f8d953704f = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedBy);
const $ec376f2b71614cc0$export$90e81c873cca1e90 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedByGroup);
const $ec376f2b71614cc0$export$300334f671c43555 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Priority);
const $ec376f2b71614cc0$export$7904b5485bf997ea = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ProgrammingLanguage);
const $ec376f2b71614cc0$export$2881499e37b75b9a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Provider);
const $ec376f2b71614cc0$export$f69df2decd5f729e = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReactCount);
const $ec376f2b71614cc0$export$77dedcd16f070a20 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReadTime);
const $ec376f2b71614cc0$export$897b145a1ed39fe5 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SentOn);
const $ec376f2b71614cc0$export$387c3264a8f67d61 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SourceBranch);
const $ec376f2b71614cc0$export$7254cc27399e90bd = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).State);
const $ec376f2b71614cc0$export$cfafe90bba8a54db = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubscriberCount);
const $ec376f2b71614cc0$export$d441f34e4c8dd9e7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubTasksProgress);
const $ec376f2b71614cc0$export$634eef04d1a9a575 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).StoryPoints);
const $ec376f2b71614cc0$export$b5e4199e062b8f44 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).TargetBranch);
const $ec376f2b71614cc0$export$f99233281efd08a0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Title);
const $ec376f2b71614cc0$export$ae2d8be089b6cfe0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ViewCount);
const $ec376f2b71614cc0$export$b080bef6ed7fa75a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).VoteCount);

});
parcelRegister("eCsaJ", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $3c92d860530d8c8b$export$c8a8987d4410bf2d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $9tslm = parcelRequire("9tslm");

var $4ZXUA = parcelRequire("4ZXUA");

var $7IZqM = parcelRequire("7IZqM");

var $bWpL0 = parcelRequire("bWpL0");

var $aWyvu = parcelRequire("aWyvu");

var $3dV67 = parcelRequire("3dV67");

var $cJxXG = parcelRequire("cJxXG");

var $77cM6 = parcelRequire("77cM6");

var $k39kU = parcelRequire("k39kU");
const $3c92d860530d8c8b$var$elementMappings = {
    [(0, $8dVIb.ElementName).AttachmentCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Attachment
        }
    },
    [(0, $8dVIb.ElementName).AuthorGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).ChecklistProgress]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).CheckItem
        }
    },
    [(0, $8dVIb.ElementName).CollaboratorGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).CommentCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Comment
        }
    },
    [(0, $8dVIb.ElementName).ViewCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).View
        }
    },
    [(0, $8dVIb.ElementName).ReactCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).React
        }
    },
    [(0, $8dVIb.ElementName).VoteCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Vote
        }
    },
    [(0, $8dVIb.ElementName).CreatedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).OwnedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).AssignedTo]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).AssignedToGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).OwnedByGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).CreatedOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).DueOn]: {
        component: (0, $cJxXG.default)
    },
    [(0, $8dVIb.ElementName).LatestCommit]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Commit
        }
    },
    [(0, $8dVIb.ElementName).LinkIcon]: {
        component: (0, $aWyvu.default)
    },
    [(0, $8dVIb.ElementName).ModifiedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).ModifiedOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).Preview]: {
        component: (0, $77cM6.default)
    },
    [(0, $8dVIb.ElementName).Priority]: {
        component: (0, $7IZqM.default)
    },
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).ProgrammingLanguage
        }
    },
    [(0, $8dVIb.ElementName).Provider]: {
        component: (0, $7IZqM.default)
    },
    [(0, $8dVIb.ElementName).ReadTime]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).SentOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).SourceBranch]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).State]: {
        component: (0, $cJxXG.default)
    },
    [(0, $8dVIb.ElementName).SubscriberCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Subscriber
        }
    },
    [(0, $8dVIb.ElementName).SubTasksProgress]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).SubTasksProgress
        }
    },
    [(0, $8dVIb.ElementName).StoryPoints]: {
        component: (0, $9tslm.default)
    },
    [(0, $8dVIb.ElementName).TargetBranch]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).Title]: {
        component: (0, $3dV67.default)
    },
    [(0, $8dVIb.ElementName).Location]: {
        component: (0, $3dV67.default),
        props: {
            theme: (0, $8dVIb.SmartLinkInternalTheme).Grey
        }
    }
};
const $3c92d860530d8c8b$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
const $3c92d860530d8c8b$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
        case (0, $8dVIb.ElementName).AuthorGroup:
        case (0, $8dVIb.ElementName).CollaboratorGroup:
        case (0, $8dVIb.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $8dVIb.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $3c92d860530d8c8b$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $8dVIb.ElementName).AttachmentCount:
        case (0, $8dVIb.ElementName).ChecklistProgress:
        case (0, $8dVIb.ElementName).CommentCount:
        case (0, $8dVIb.ElementName).ViewCount:
        case (0, $8dVIb.ElementName).ReactCount:
        case (0, $8dVIb.ElementName).VoteCount:
        case (0, $8dVIb.ElementName).ProgrammingLanguage:
        case (0, $8dVIb.ElementName).SubscriberCount:
        case (0, $8dVIb.ElementName).LatestCommit:
        case (0, $8dVIb.ElementName).SubTasksProgress:
            return $3c92d860530d8c8b$var$toBadgeProps(data);
        case (0, $8dVIb.ElementName).StoryPoints:
            return $3c92d860530d8c8b$var$toAtlaskitBadgeProps(data);
        case (0, $8dVIb.ElementName).CreatedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).created_by, context.createdBy);
        case (0, $8dVIb.ElementName).AssignedTo:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).assigned_to, context.assignedTo);
        case (0, $8dVIb.ElementName).OwnedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).owned_by, context.ownedBy);
        case (0, $8dVIb.ElementName).CreatedOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('created', context.createdOn);
        case (0, $8dVIb.ElementName).DueOn:
            return $3c92d860530d8c8b$var$toDateLozengeProps(context.dueOn);
        case (0, $8dVIb.ElementName).ModifiedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).modified_by, context.modifiedBy);
        case (0, $8dVIb.ElementName).ModifiedOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $8dVIb.ElementName).SentOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('sent', context.sentOn);
        case (0, $8dVIb.ElementName).ReadTime:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).read_time, data);
        case (0, $8dVIb.ElementName).SourceBranch:
        case (0, $8dVIb.ElementName).TargetBranch:
            return $3c92d860530d8c8b$var$toTextProps(data);
        case (0, $8dVIb.ElementName).Title:
            return $3c92d860530d8c8b$var$toLinkProps(context.title, context.url);
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $3c92d860530d8c8b$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $3c92d860530d8c8b$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $3c92d860530d8c8b$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $3c92d860530d8c8b$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VHMR.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $3c92d860530d8c8b$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $3c92d860530d8c8b$var$toFormattedTextProps = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $3c92d860530d8c8b$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $3c92d860530d8c8b$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $3c92d860530d8c8b$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $3c92d860530d8c8b$var$elementMappings[name] || {};
    const contextKey = $3c92d860530d8c8b$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
        const data = $3c92d860530d8c8b$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, $2OMIu.jsx)(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("7zaVw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a298b78183f16654$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a298b78183f16654$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    more_information_about_this_work_item: {
        id: 'fabric.linking.more_information_about_this_work_item',
        defaultMessage: 'More information about this work item',
        description: 'Allows the users to see more about the work item'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_modal_title_v2: {
        id: 'fabric.linking.related_links_modal_title_v2',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_found_in_v2: {
        id: 'fabric.linking.related_links_found_in_v2',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_includes_links_to_v2: {
        id: 'fabric.linking.related_links_includes_links_to_v2',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    }
});

});

parcelRegister("9tslm", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf2a1e857857107e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $VSDnB = parcelRequire("VSDnB");
const $bf2a1e857857107e$var$badgeStylesOld = null;
const $bf2a1e857857107e$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $bf2a1e857857107e$var$AtlaskitBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $16T6Y.default), {
            children: value
        })
    });
};
var $bf2a1e857857107e$export$2e2bcd8739ae039 = $bf2a1e857857107e$var$AtlaskitBadge;

});

parcelRegister("4ZXUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e655d051c837701$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $jnhNB = parcelRequire("jnhNB");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $fpDmE = parcelRequire("fpDmE");
const $1e655d051c837701$var$MAX_COUNT = 4;
const $1e655d051c837701$var$styles = null;
const $1e655d051c837701$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxu2gc _102oidpf",
    large: "_1e0c116y _1kvxu2gc _102oidpf",
    medium: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $1e655d051c837701$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).assigned_to, personName);
        case (0, $8dVIb.ElementName).OwnedByGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).owned_by, personName);
        case (0, $8dVIb.ElementName).AuthorGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $1e655d051c837701$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $1e655d051c837701$var$MAX_COUNT, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $koVbs.default)();
    const data = (0, $5uXOq.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $8dVIb.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $1e655d051c837701$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $1e655d051c837701$var$stylesMap[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnhNB.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $1e655d051c837701$export$2e2bcd8739ae039 = $1e655d051c837701$var$AvatarGroup;

});
parcelRegister("fpDmE", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $3ebf94f205ad0182$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $3ebf94f205ad0182$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $3ebf94f205ad0182$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidthNew", () => $3ebf94f205ad0182$export$86b6226ea65a6ddf);
$parcel$export(module.exports, "getIconWidth", () => $3ebf94f205ad0182$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $3ebf94f205ad0182$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $3ebf94f205ad0182$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $3ebf94f205ad0182$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $3ebf94f205ad0182$export$619e376a425cb759);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");
const $3ebf94f205ad0182$export$9d642f65a919fb93 = {
    [(0, $8dVIb.SmartLinkSize).Small]: 'none',
    [(0, $8dVIb.SmartLinkSize).Medium]: 'compact',
    [(0, $8dVIb.SmartLinkSize).Large]: 'compact',
    [(0, $8dVIb.SmartLinkSize).XLarge]: 'default'
};
const $3ebf94f205ad0182$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descriptor,
            values: values
        });
    }
};
const $3ebf94f205ad0182$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $3ebf94f205ad0182$export$ce56b6021549537 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return '2rem';
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return '1rem';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '.75rem';
    }
};
const $3ebf94f205ad0182$export$86b6226ea65a6ddf = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $3ebf94f205ad0182$export$fb10bc5609c6347e = (size)=>{
    return (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? $3ebf94f205ad0182$export$86b6226ea65a6ddf(size) : $3ebf94f205ad0182$export$ce56b6021549537(size);
};
const $3ebf94f205ad0182$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $3ebf94f205ad0182$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1.75;
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $3ebf94f205ad0182$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $3ebf94f205ad0182$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $8dVIb.SmartLinkSize).Large:
            return 'space.200';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $3ebf94f205ad0182$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});


parcelRegister("7IZqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab9f19acb0d3ec1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $3dubP = parcelRequire("3dubP");

var $fpDmE = parcelRequire("fpDmE");
const $aab9f19acb0d3ec1$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $aab9f19acb0d3ec1$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $aab9f19acb0d3ec1$var$badgeStyles = null;
const $aab9f19acb0d3ec1$var$iconStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $aab9f19acb0d3ec1$var$labelStylesOld = null;
const $aab9f19acb0d3ec1$var$messageMapper = {
    [(0, $8dVIb.IconType).PriorityBlocker]: (0, $7zaVw.messages).priority_blocker,
    [(0, $8dVIb.IconType).PriorityCritical]: (0, $7zaVw.messages).priority_critical,
    [(0, $8dVIb.IconType).PriorityHigh]: (0, $7zaVw.messages).priority_high,
    [(0, $8dVIb.IconType).PriorityHighest]: (0, $7zaVw.messages).priority_highest,
    [(0, $8dVIb.IconType).PriorityLow]: (0, $7zaVw.messages).priority_low,
    [(0, $8dVIb.IconType).PriorityLowest]: (0, $7zaVw.messages).priority_lowest,
    [(0, $8dVIb.IconType).PriorityMajor]: (0, $7zaVw.messages).priority_major,
    [(0, $8dVIb.IconType).PriorityMedium]: (0, $7zaVw.messages).priority_medium,
    [(0, $8dVIb.IconType).PriorityMinor]: (0, $7zaVw.messages).priority_minor,
    [(0, $8dVIb.IconType).PriorityTrivial]: (0, $7zaVw.messages).priority_trivial,
    [(0, $8dVIb.IconType).PriorityUndefined]: (0, $7zaVw.messages).priority_undefined
};
const $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $aab9f19acb0d3ec1$var$messageMapper[icon];
        if (descriptor) return (0, $fpDmE.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $aab9f19acb0d3ec1$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Hdrc.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $aab9f19acb0d3ec1$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $aab9f19acb0d3ec1$var$BadgeRefreshNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url }, ref)=>{
    const formattedMessageOrLabel = $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $aab9f19acb0d3ec1$var$renderAtlaskitIcon(icon, testId) || $aab9f19acb0d3ec1$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            $aab9f19acb0d3ec1$var$styles.container,
            $aab9f19acb0d3ec1$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                xcss: $aab9f19acb0d3ec1$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $aab9f19acb0d3ec1$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(Badge);
const $aab9f19acb0d3ec1$var$BadgeRefreshNewWithOverrideCss = (0, $3dubP.withOverrideCss)($aab9f19acb0d3ec1$var$BadgeRefreshNew);
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $aab9f19acb0d3ec1$var$BadgeCompiledNew = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, className: className, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $aab9f19acb0d3ec1$var$renderAtlaskitIcon(icon, testId) || $aab9f19acb0d3ec1$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_16jlidpf _1o9zidpf _i0dl1wug _syaz1oju _vwz4idpf _s7n4nkob _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v _1jtnidpf _13t3idpf _rm9uidpf _rtqbnkob _e4kmnkob _z239nkob"
                ]),
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": `${testId}-label`,
                className: (0, $bwpsq.default)([
                    "_11c8dcr7 _syaz131l _19bv1xvx _s7n4nkob"
                ]),
                children: formattedMessageOrLabel
            })
        ]
    });
};
const $aab9f19acb0d3ec1$var$Badge = (props)=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)($aab9f19acb0d3ec1$var$BadgeRefreshNewWithOverrideCss, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)($aab9f19acb0d3ec1$var$BadgeCompiledNew, {
        ...props
    });
};
var $aab9f19acb0d3ec1$export$2e2bcd8739ae039 = $aab9f19acb0d3ec1$var$Badge;

});
parcelRegister("9Hdrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1647af7fe5459c6c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $duwKf = parcelRequire("duwKf");

var $iRZQl = parcelRequire("iRZQl");

var $7anl7 = parcelRequire("7anl7");
var $29YN9 = parcelRequire("29YN9");

var $VSDnB = parcelRequire("VSDnB");


var $dVpJZ = parcelRequire("dVpJZ");

var $e1vlu = parcelRequire("e1vlu");

var $94rku = parcelRequire("94rku");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");





























































// prettier-ignore
const $1647af7fe5459c6c$var$importIconMapperOld = {
    [(0, $8dVIb.IconType).Archive]: ()=>(parcelRequire("4m4MY")),
    [(0, $8dVIb.IconType).Audio]: ()=>(parcelRequire("5nV2R")),
    [(0, $8dVIb.IconType).Code]: ()=>(parcelRequire("coOzc")),
    [(0, $8dVIb.IconType).Executable]: ()=>(parcelRequire("gmDdF")),
    [(0, $8dVIb.IconType).File]: ()=>(parcelRequire("ldQLy")),
    [(0, $8dVIb.IconType).Folder]: ()=>(parcelRequire("fjtI4")),
    [(0, $8dVIb.IconType).Generic]: ()=>(parcelRequire("ldQLy")),
    [(0, $8dVIb.IconType).GIF]: ()=>(parcelRequire("eogSM")),
    [(0, $8dVIb.IconType).GoogleDocs]: ()=>(parcelRequire("6q8Pr")),
    [(0, $8dVIb.IconType).GoogleForms]: ()=>(parcelRequire("3VL73")),
    [(0, $8dVIb.IconType).GoogleSheets]: ()=>(parcelRequire("bwXIZ")),
    [(0, $8dVIb.IconType).GoogleSlides]: ()=>(parcelRequire("6SoQO")),
    [(0, $8dVIb.IconType).Image]: ()=>(parcelRequire("ifmtc")),
    [(0, $8dVIb.IconType).MSExcel]: ()=>(parcelRequire("8vv4H")),
    [(0, $8dVIb.IconType).MSPowerpoint]: ()=>(parcelRequire("TZHl8")),
    [(0, $8dVIb.IconType).MSWord]: ()=>(parcelRequire("e3PhT")),
    [(0, $8dVIb.IconType).PDF]: ()=>(parcelRequire("55TA3")),
    [(0, $8dVIb.IconType).Presentation]: ()=>(parcelRequire("2t9Hh")),
    [(0, $8dVIb.IconType).Sketch]: ()=>(parcelRequire("4WgJk")),
    [(0, $8dVIb.IconType).Spreadsheet]: ()=>(parcelRequire("lb4t9")),
    [(0, $8dVIb.IconType).Template]: ()=>(parcelRequire("60qz8")),
    [(0, $8dVIb.IconType).Video]: ()=>(parcelRequire("6Y2WT")),
    // Bitbucket icons
    [(0, $8dVIb.IconType).Branch]: ()=>(parcelRequire("cAU6j")),
    [(0, $8dVIb.IconType).Commit]: ()=>(parcelRequire("bn2CC")),
    [(0, $8dVIb.IconType).Project]: ()=>Promise.resolve((parcelRequire("kFO36"))),
    [(0, $8dVIb.IconType).PullRequest]: ()=>(parcelRequire("cIR4U")),
    [(0, $8dVIb.IconType).Repo]: ()=>(parcelRequire("bbgWK")),
    // Jira icons
    [(0, $8dVIb.IconType).Bug]: ()=>(parcelRequire("jNgVH")),
    [(0, $8dVIb.IconType).Change]: ()=>(parcelRequire("hhL96")),
    [(0, $8dVIb.IconType).Epic]: ()=>(parcelRequire("9q15g")),
    [(0, $8dVIb.IconType).Incident]: ()=>(parcelRequire("14Fhu")),
    [(0, $8dVIb.IconType).Problem]: ()=>(parcelRequire("3Qygt")),
    [(0, $8dVIb.IconType).ServiceRequest]: ()=>(parcelRequire("7J5Ma")),
    [(0, $8dVIb.IconType).Story]: ()=>(parcelRequire("iErKi")),
    [(0, $8dVIb.IconType).SubTask]: ()=>(parcelRequire("kBegL")),
    [(0, $8dVIb.IconType).Task]: ()=>(parcelRequire("dqT3O")),
    // Provider icons
    [(0, $8dVIb.IconType).Confluence]: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                default: ConfluenceIcon
            })),
    [(0, $8dVIb.IconType).Jira]: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                default: JiraIcon
            })),
    // Fallback icons
    [(0, $8dVIb.IconType).Default]: ()=>Promise.resolve((parcelRequire("458iJ"))),
    [(0, $8dVIb.IconType).Error]: ()=>Promise.resolve((parcelRequire("7nnPp"))),
    [(0, $8dVIb.IconType).Forbidden]: ()=>(parcelRequire("414ys")),
    // Badge
    [(0, $8dVIb.IconType).Attachment]: ()=>(parcelRequire("kbM6l")),
    [(0, $8dVIb.IconType).CheckItem]: ()=>(parcelRequire("iiba0")),
    [(0, $8dVIb.IconType).Comment]: ()=>(parcelRequire("etExZ")),
    [(0, $8dVIb.IconType).View]: ()=>(parcelRequire("hyIrG")),
    [(0, $8dVIb.IconType).React]: ()=>(parcelRequire("h8l0B")),
    [(0, $8dVIb.IconType).Vote]: ()=>(parcelRequire("4CGRY")),
    [(0, $8dVIb.IconType).PriorityBlocker]: ()=>(parcelRequire("gMDFI")),
    [(0, $8dVIb.IconType).PriorityCritical]: ()=>(parcelRequire("4fkVg")),
    [(0, $8dVIb.IconType).PriorityHigh]: ()=>(parcelRequire("fgN6p")),
    [(0, $8dVIb.IconType).PriorityHighest]: ()=>(parcelRequire("cV2N9")),
    [(0, $8dVIb.IconType).PriorityLow]: ()=>(parcelRequire("eVavM")),
    [(0, $8dVIb.IconType).PriorityLowest]: ()=>(parcelRequire("56RVo")),
    [(0, $8dVIb.IconType).PriorityMajor]: ()=>(parcelRequire("ktXnL")),
    [(0, $8dVIb.IconType).PriorityMedium]: ()=>(parcelRequire("9mM5H")),
    [(0, $8dVIb.IconType).PriorityMinor]: ()=>(parcelRequire("1O0Re")),
    [(0, $8dVIb.IconType).PriorityTrivial]: ()=>(parcelRequire("lGGho")),
    [(0, $8dVIb.IconType).PriorityUndefined]: ()=>(parcelRequire("bNddV")),
    [(0, $8dVIb.IconType).ProgrammingLanguage]: ()=>(parcelRequire("7Hzmn")),
    [(0, $8dVIb.IconType).Subscriber]: ()=>Promise.resolve((parcelRequire("h8cgU"))),
    [(0, $8dVIb.IconType).SubTasksProgress]: ()=>(parcelRequire("jZ8wH"))
};
const $1647af7fe5459c6c$var$getIconImportFn = (icon, size)=>{
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) {
        const item = (0, $kxcRq.getLazyIcons)()[icon];
        if ((0, $kxcRq.isIconSizeLarge)(size) && item?.large) return item.large;
        return item?.default;
    }
    return $1647af7fe5459c6c$var$importIconMapperOld[icon];
};
const $1647af7fe5459c6c$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $1647af7fe5459c6c$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $8dVIb.SmartLinkSize).Medium })=>{
    const DocumentIcon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? (0, $94rku.default) : (0, (/*@__PURE__*/$parcel$interopDefault($duwKf)));
    const BlogIcon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? (0, $dVpJZ.default) : (0, $iRZQl.default);
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $8dVIb.IconType).Document:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(DocumentIcon, {
                label: label ?? 'document',
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
        case (0, $8dVIb.IconType).Blog:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(BlogIcon, {
                label: label ?? 'blog',
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
        case (0, $8dVIb.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e1vlu.default), {
                label: label ?? 'live-doc',
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
    }
    const importFn = $1647af7fe5459c6c$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $1647af7fe5459c6c$var$importIcon(importFn);
    switch(icon){
        case (0, $8dVIb.IconType).Confluence:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7anl7.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size === (0, $8dVIb.SmartLinkSize).Large ? 'small' : 'xsmall'
                }
            });
        case (0, $8dVIb.IconType).Jira:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $29YN9.JiraIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size === (0, $8dVIb.SmartLinkSize).Large ? 'small' : 'xsmall'
                }
            });
        case (0, $8dVIb.IconType).Error:
        case (0, $8dVIb.IconType).Forbidden:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') ? {
                    size: size,
                    color: "var(--ds-icon-danger, #C9372C)"
                } : {
                    primaryColor: `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`
                }
            });
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
    }
};
var $1647af7fe5459c6c$export$2e2bcd8739ae039 = $1647af7fe5459c6c$var$AtlaskitIcon;

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("e1vlu", function(module, exports) {

$parcel$export(module.exports, "default", () => $df3c19aa4679ee0a$export$2e2bcd8739ae039);

var $4Atwu = parcelRequire("4Atwu");

var $8lQ8Y = parcelRequire("8lQ8Y");

var $50H21 = parcelRequire("50H21");
const $df3c19aa4679ee0a$var$LiveDocumentIconWithColor = (0, $50H21.renderIconPerSize)((0, $4Atwu.default), (0, $8lQ8Y.default));
$df3c19aa4679ee0a$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $df3c19aa4679ee0a$export$2e2bcd8739ae039 = $df3c19aa4679ee0a$var$LiveDocumentIconWithColor;

});

parcelRegister("60qz8", function(module, exports) {

let $45f7598832a79dac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45f7598832a79dac$var$load("dtoNN").then(()=>parcelRequire('53J27'));

});

parcelRegister("414ys", function(module, exports) {

let $2ecac9e0a8f149c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2ecac9e0a8f149c4$var$load("j1srk").then(()=>parcelRequire('gs7PQ'));

});

parcelRegister("kbM6l", function(module, exports) {

let $eb2a25a65dcb50b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb2a25a65dcb50b4$var$load("gWXGh").then(()=>parcelRequire('j3Vfq'));

});

parcelRegister("iiba0", function(module, exports) {

let $d51290a7bc53dd95$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d51290a7bc53dd95$var$load("geqFV").then(()=>parcelRequire('imUQY'));

});

parcelRegister("etExZ", function(module, exports) {

let $a8a339f19c570aad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a8a339f19c570aad$var$load("a5nLi").then(()=>parcelRequire('DBbS0'));

});

parcelRegister("hyIrG", function(module, exports) {

let $cc881699a67c12c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc881699a67c12c9$var$load("97YHa").then(()=>parcelRequire('bH0nF'));

});

parcelRegister("h8l0B", function(module, exports) {

let $c7937af0943f4fdc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c7937af0943f4fdc$var$load("cj5mx").then(()=>parcelRequire('kxkv9'));

});

parcelRegister("4CGRY", function(module, exports) {

let $35dbf7027bf16f47$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35dbf7027bf16f47$var$load("7SKVs").then(()=>parcelRequire('kAObg'));

});

parcelRegister("bNddV", function(module, exports) {

let $895e873ca6529ff2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $895e873ca6529ff2$var$load("h2MrD"),
    $895e873ca6529ff2$var$load("bYT2S"),
    $895e873ca6529ff2$var$load("8YLm9")
]).then(()=>parcelRequire('7QGmb'));

});

parcelRegister("7Hzmn", function(module, exports) {

let $59b7fa4a04481570$var$load = (parcelRequire("28QjX"))(4);
module.exports = $59b7fa4a04481570$var$load("iY2wN").then(()=>parcelRequire('c2JK5'));

});

parcelRegister("jZ8wH", function(module, exports) {

let $e8ca53f8b2e599bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e8ca53f8b2e599bd$var$load("10dT8").then(()=>parcelRequire('gKopa'));

});


parcelRegister("l5Xsv", function(module, exports) {

$parcel$export(module.exports, "default", () => $951590e808a48e01$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bmnhy = parcelRequire("bmnhy");

var $VSDnB = parcelRequire("VSDnB");

var $gU02S = parcelRequire("gU02S");
const $951590e808a48e01$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
        src: url,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') ? {
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonNew), {
                testId: `${testId}-loading`,
                width: width,
                height: height
            }),
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: url,
                "data-testid": `${testId}-image`,
                alt: "",
                style: {
                    width: width,
                    height: height
                }
            })
        } : {
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonOld), {
                testId: `${testId}-loading`
            }),
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: url,
                "data-testid": `${testId}-image`,
                alt: ""
            })
        },
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $951590e808a48e01$export$2e2bcd8739ae039 = $951590e808a48e01$var$ImageIcon;

});
parcelRegister("bmnhy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8453cf1ee7ef4644$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8453cf1ee7ef4644$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $8453cf1ee7ef4644$var$loaded() {
    return {
        isLoaded: true
    };
}
function $8453cf1ee7ef4644$var$errored() {
    return {
        isErrored: true
    };
}
function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
    $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
    }
    $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($8453cf1ee7ef4644$var$React.Component);
module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;

});

parcelRegister("gU02S", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeletonNew", () => $880176eb12ae8419$export$4c64943f69fac55);
$parcel$export(module.exports, "LoadingSkeletonOld", () => $880176eb12ae8419$export$c2c783ba34989c94);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $880176eb12ae8419$var$animationNameStyles = null;
const $880176eb12ae8419$var$loadingSkeletonStyle = null;
const $880176eb12ae8419$export$4c64943f69fac55 = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};
const $880176eb12ae8419$export$c2c783ba34989c94 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($880176eb12ae8419$export$4c64943f69fac55, {
        ...props,
        width: `${props.width}rem`,
        height: `${props.height}rem`
    });
};

});


parcelRegister("3dubP", function(module, exports) {

$parcel$export(module.exports, "withOverrideCss", () => $9f9aac8ddfd1f0ad$export$e0bdcacb944f1da6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $9f9aac8ddfd1f0ad$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});


parcelRegister("bWpL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a4f7878d6976fe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7anB = parcelRequire("j7anB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $66a4f7878d6976fe$var$stylesOld = null;
const $66a4f7878d6976fe$var$styles = null;
const $66a4f7878d6976fe$var$typeToDescriptorMap = {
    created: {
        relative: (0, $7zaVw.messages).created_on_relative,
        absolute: (0, $7zaVw.messages).created_on_absolute
    },
    modified: {
        relative: (0, $7zaVw.messages).modified_on_relative,
        absolute: (0, $7zaVw.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $7zaVw.messages).sent_on_relative,
        absolute: (0, $7zaVw.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $66a4f7878d6976fe$var$DateTime = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $koVbs.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $j7anB.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k1j6v",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            className
        ]),
        children: text ? `${text} ${context}` : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$66a4f7878d6976fe$var$typeToDescriptorMap[type][typeVariant],
            values: {
                context: context
            }
        })
    });
};
var $66a4f7878d6976fe$export$2e2bcd8739ae039 = $66a4f7878d6976fe$var$DateTime;

});

parcelRegister("aWyvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6c193b1fc074556$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");
const $d6c193b1fc074556$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $d6c193b1fc074556$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $d6c193b1fc074556$var$iconStylesMapOld = {
    xlarge: "_16jlidpf _1o9zidpf _i0dl1wug _4t3iviql _1tkeviql _c71lviql _1bsbviql _1ul9viql _p12fviql _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7viql _1xjxviql _1752viql _qci8viql _15izviql _erubviql _19l3viql _1pr2viql _1u5tviql _mezjviql _e2ooviql _w8l5viql _1rg2viql _q7cvviql _xwbjviql _rtysviql _b8nkviql _4x20viql",
    large: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    medium: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    small: "_16jlidpf _1o9zidpf _i0dl1wug _4t3ioqnp _1tkeoqnp _c71loqnp _1bsboqnp _1ul9oqnp _p12foqnp _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7oqnp _1xjxoqnp _1752oqnp _qci8oqnp _15izoqnp _eruboqnp _19l3oqnp _1pr2oqnp _1u5toqnp _mezjoqnp _e2oooqnp _w8l5oqnp _1rg2oqnp _q7cvoqnp _xwbjoqnp _rtysoqnp _b8nkoqnp _4x20oqnp"
};
const $d6c193b1fc074556$var$customRenderStyleMapOld = {
    xlarge: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz4viql _1wybviql _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kviql",
    large: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz41k8s _1wyb1k8s _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102k1k8s",
    medium: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz41j6v _1wyb1j6v _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102k1j6v",
    small: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz4oqnp _1wyboqnp _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102koqnp"
};
const $d6c193b1fc074556$var$customRenderStyleMapNew = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kptym"
};
const $d6c193b1fc074556$var$renderAtlaskitIcon = (icon, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Hdrc.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            size: size
        }
    });
};
const $d6c193b1fc074556$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $d6c193b1fc074556$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    const width = size === (0, $8dVIb.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            width: width,
            height: width
        }
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $d6c193b1fc074556$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $8dVIb.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
    const element = (0, $5uXOq.useMemo)(()=>{
        const defaultIcon = $d6c193b1fc074556$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $d6c193b1fc074556$var$renderImageIcon(defaultIcon, url, testId, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? size : undefined) || $d6c193b1fc074556$var$renderAtlaskitIcon(icon, testId, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? size : undefined) || defaultIcon;
    }, [
        overrideIcon,
        icon,
        label,
        render,
        testId,
        url,
        size
    ]);
    const width = (0, $fpDmE.getIconWidth)(size);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $d6c193b1fc074556$var$styles.container,
            !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$iconStylesMapOld[size],
            !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$positionStyleMap[position],
            render && !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$customRenderStyleMapOld[size],
            render && (0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$customRenderStyleMapNew[size],
            className
        ]),
        children: (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $d6c193b1fc074556$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        }) : element
    });
};
var $d6c193b1fc074556$export$2e2bcd8739ae039 = $d6c193b1fc074556$var$Icon;

});

parcelRegister("3dV67", function(module, exports) {

$parcel$export(module.exports, "default", () => $b60bb11df77d728a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $fpDmE = parcelRequire("fpDmE");
const $b60bb11df77d728a$var$DEFAULT_MAX_LINES = 2;
const $b60bb11df77d728a$var$MAXIMUM_MAX_LINES = 2;
const $b60bb11df77d728a$var$MINIMUM_MAX_LINES = 1;
const $b60bb11df77d728a$var$containerStyles = null;
const $b60bb11df77d728a$var$getMaxLines = (maxLines)=>{
    if (maxLines > $b60bb11df77d728a$var$MAXIMUM_MAX_LINES) return $b60bb11df77d728a$var$DEFAULT_MAX_LINES;
    if (maxLines < $b60bb11df77d728a$var$MINIMUM_MAX_LINES) return $b60bb11df77d728a$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $b60bb11df77d728a$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $b60bb11df77d728a$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $b60bb11df77d728a$var$baseAnchorStyle = null;
const $b60bb11df77d728a$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $b60bb11df77d728a$var$anchorConstantsStyles = null;
const $b60bb11df77d728a$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $b60bb11df77d728a$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $b60bb11df77d728a$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $b60bb11df77d728a$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $b60bb11df77d728a$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $b60bb11df77d728a$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $8dVIb.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, $fpDmE.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $b60bb11df77d728a$var$linkStyleSizeMap[size],
            $b60bb11df77d728a$var$anchorLineClampMap[$b60bb11df77d728a$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $b60bb11df77d728a$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $b60bb11df77d728a$var$getMaxLines(maxLines) === 1 && $b60bb11df77d728a$var$anchorLinkLineHeight1Map[size],
            $b60bb11df77d728a$var$getMaxLines(maxLines) === 2 && $b60bb11df77d728a$var$anchorLinkLineHeight2Map[size],
            $b60bb11df77d728a$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $b60bb11df77d728a$var$withTooltip(anchor, text, testId)
    });
};
var $b60bb11df77d728a$export$2e2bcd8739ae039 = $b60bb11df77d728a$var$Link;

});
parcelRegister("4URMI", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $0d5ea96be37e2b5d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $0d5ea96be37e2b5d$export$df67f318ded0283c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $g2eZ6 = parcelRequire("g2eZ6");
var $0d5ea96be37e2b5d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
    return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
};

});
parcelRegister("g2eZ6", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $473b45d487f9fd1b$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $473b45d487f9fd1b$export$263352d59c0c5966);

var $5uXOq = parcelRequire("5uXOq");

var $b6uPu = parcelRequire("b6uPu");

var $4URMI = parcelRequire("4URMI");

var $fzJZi = parcelRequire("fzJZi");
const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $b6uPu.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4URMI.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4URMI.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("b6uPu", function(module, exports) {

$parcel$export(module.exports, "browser", () => $7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
const $7f7209ce5c1e8d08$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
    return $7f7209ce5c1e8d08$var$result;
}

});




parcelRegister("cJxXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $af9c30eaf441ad65$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $a4DH1 = parcelRequire("a4DH1");
const $af9c30eaf441ad65$var$stylesOld = null;
const $af9c30eaf441ad65$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $af9c30eaf441ad65$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a4DH1.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
        appearance: appearance,
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41kw7",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $af9c30eaf441ad65$export$2e2bcd8739ae039 = $af9c30eaf441ad65$var$Lozenge;

});
parcelRegister("a4DH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $27ceba18caf6f022$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $dlJZx = parcelRequire("dlJZx");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $gDUps = parcelRequire("gDUps");

var $fzJZi = parcelRequire("fzJZi");

var $cLKee = parcelRequire("cLKee");

var $dMzTJ = parcelRequire("dMzTJ");

var $j6VJk = parcelRequire("j6VJk");

var $1s0lY = parcelRequire("1s0lY");

var $kf01E = parcelRequire("kf01E");

var $4Dg4o = parcelRequire("4Dg4o");
const $27ceba18caf6f022$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $27ceba18caf6f022$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $5uXOq.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [items, setItems] = (0, $5uXOq.useState)();
    const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)();
    const reload = (0, $f22ja.default)();
    const invoke = (0, $3q2sI.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $5uXOq.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $dlJZx.default));
                const validItems = typeof text === 'string' ? $27ceba18caf6f022$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? (0, $1s0lY.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $1s0lY.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $1s0lY.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4Dg4o.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $5uXOq.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $gDUps.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $euMlu.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $1s0lY.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $5uXOq.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j6VJk.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kf01E.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $27ceba18caf6f022$export$2e2bcd8739ae039 = (0, $cLKee.default)($27ceba18caf6f022$var$LozengeAction);

});
parcelRegister("dlJZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eaacaffc693a3ec$export$2e2bcd8739ae039);
const $6eaacaffc693a3ec$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $6eaacaffc693a3ec$export$2e2bcd8739ae039 = $6eaacaffc693a3ec$var$extractLozengeActionItems;

});

parcelRegister("3q2sI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a60e7c58b54588$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iiAnG = parcelRequire("iiAnG");

var $051X7 = parcelRequire("051X7");
const $f5a60e7c58b54588$var$useInvoke = ()=>{
    const { connections: connections } = (0, $051X7.useSmartLinkContext)();
    const clientExt = (0, $iiAnG.useSmartLinkClientExtension)(connections.client);
    return (0, $5uXOq.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $f5a60e7c58b54588$export$2e2bcd8739ae039 = $f5a60e7c58b54588$var$useInvoke;

});
parcelRegister("iiAnG", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $ffb669da1b6b71e8$export$303ede4eed148855);

var $5uXOq = parcelRequire("5uXOq");

var $dV0Jy = parcelRequire("dV0Jy");

var $T540Y = parcelRequire("T540Y");

var $3b94d = parcelRequire("3b94d");
const $ffb669da1b6b71e8$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $3b94d.useResolverUrl)(cardClient);
    const invoke = (0, $5uXOq.useCallback)(async (data)=>{
        try {
            return await (0, $dV0Jy.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $T540Y.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("T540Y", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $171ae91e706973ef$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $171ae91e706973ef$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $171ae91e706973ef$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $171ae91e706973ef$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("3b94d", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $eebf021c5f687360$export$d08617a365fbe694);

var $5uXOq = parcelRequire("5uXOq");

var $itO4f = parcelRequire("itO4f");
const $eebf021c5f687360$export$d08617a365fbe694 = (cardClient)=>(0, $5uXOq.useMemo)(()=>(0, $itO4f.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("euMlu", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $0ad6fedaface02c5$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $0ad6fedaface02c5$export$1694272377fa07d8);

var $fzJZi = parcelRequire("fzJZi");
const $0ad6fedaface02c5$export$65b3f792dff0bd60 = (err)=>{
    if (!$0ad6fedaface02c5$export$1694272377fa07d8(err)) return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $fzJZi.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    }
};
const $0ad6fedaface02c5$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("f22ja", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48b36e6e5cada34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kYwnb = parcelRequire("kYwnb");

var $051X7 = parcelRequire("051X7");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $nb8r1 = parcelRequire("nb8r1");
const $f48b36e6e5cada34$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $nb8r1.default)();
    return (0, $5uXOq.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = (0, $VSDnB.fg)('smart_links_noun_support') ? !!(details && details.data || (0, $kYwnb.isEntityPresent)(details)) : !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1VPdD.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $f48b36e6e5cada34$export$2e2bcd8739ae039 = $f48b36e6e5cada34$var$useResolve;

});
parcelRegister("nb8r1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09545a48e55da9e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $051X7 = parcelRequire("051X7");

var $2yPrN = parcelRequire("2yPrN");
var $kDZ6Z = parcelRequire("kDZ6Z");
var $fiKQs = parcelRequire("fiKQs");

var $8dVIb = parcelRequire("8dVIb");

var $aOsut = parcelRequire("aOsut");

const $09545a48e55da9e9$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $5uXOq.useCallback)((url, metadataStatus)=>{
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $5uXOq.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: url
        }, (0, $aOsut.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $fiKQs.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fallback', hostname, (0, $cc6a74b99a201fc4$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fatal', hostname, (0, $cc6a74b99a201fc4$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('error', hostname, (0, $cc6a74b99a201fc4$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $7nsd3.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $09545a48e55da9e9$export$2e2bcd8739ae039 = $09545a48e55da9e9$var$useResponse;

});
parcelRegister("aOsut", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $5dc57cbabb8840da$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $5dc57cbabb8840da$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $5dc57cbabb8840da$export$e32193033a594efb);
const $5dc57cbabb8840da$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $5dc57cbabb8840da$export$2796a804c6e44f63 = ()=>$5dc57cbabb8840da$var$emptyData;
const $5dc57cbabb8840da$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });
const $5dc57cbabb8840da$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });

});

const $cc6a74b99a201fc4$export$297c39c8b9bfca0 = 'resolving';
const $cc6a74b99a201fc4$export$b64a888338c24e0e = 'errored';
const $cc6a74b99a201fc4$export$677b6edfa0002c70 = 'fallback';
const $cc6a74b99a201fc4$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $cc6a74b99a201fc4$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $cc6a74b99a201fc4$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("gDUps", function(module, exports) {

$parcel$export(module.exports, "default", () => $66cd4b0a305f86bf$export$2e2bcd8739ae039);
const $66cd4b0a305f86bf$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $66cd4b0a305f86bf$export$2e2bcd8739ae039 = $66cd4b0a305f86bf$var$createStatusUpdateRequest;

});

parcelRegister("cLKee", function(module, exports) {

$parcel$export(module.exports, "default", () => $061d6f2e0c766414$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");
const $061d6f2e0c766414$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: props?.appearance,
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            })
        });
    };
var $061d6f2e0c766414$export$2e2bcd8739ae039 = $061d6f2e0c766414$var$withErrorBoundary;

});

parcelRegister("dMzTJ", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$618660b8f2aa87e2);
const $bd6f9a689b54b40e$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $bd6f9a689b54b40e$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $bd6f9a689b54b40e$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $bd6f9a689b54b40e$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("j6VJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee1a9d5bb42f1de9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $dD7Zc = parcelRequire("dD7Zc");

var $VSDnB = parcelRequire("VSDnB");


var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $iPVbQ = parcelRequire("iPVbQ");

var $fpDmE = parcelRequire("fpDmE");
const $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER = 8;
const $ee1a9d5bb42f1de9$var$contentStyles = null;
const $ee1a9d5bb42f1de9$var$linkStyles = null;
const $ee1a9d5bb42f1de9$var$textStylesBase = null;
const $ee1a9d5bb42f1de9$var$dropdownItemGroupStyles = null;
const $ee1a9d5bb42f1de9$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const invoke = (0, $iPVbQ.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $bwpsq.default)([
                                "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $lD23V.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $fpDmE.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                        target: "_blank",
                        "data-testid": `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        children: (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $bwpsq.default)([
            "_14hp1wdt _6pup1kw7 _1eo073ad"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $ee1a9d5bb42f1de9$export$2e2bcd8739ae039 = $ee1a9d5bb42f1de9$var$LozengeActionError;

});
parcelRegister("iPVbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a560b45251b869c0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $a1vqi = parcelRequire("a1vqi");

var $5vDFA = parcelRequire("5vDFA");

var $1VPdD = parcelRequire("1VPdD");
const $a560b45251b869c0$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $a560b45251b869c0$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $5uXOq.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $5vDFA.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1VPdD.startUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $5vDFA.mark(markName, 'resolved');
            (0, $1VPdD.succeedUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $5vDFA.mark(markName, 'errored');
            (0, $1VPdD.failUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $a560b45251b869c0$export$2e2bcd8739ae039 = $a560b45251b869c0$var$useInvokeClientAction;

});
parcelRegister("5vDFA", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $483ef2a5b4b04745$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $483ef2a5b4b04745$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $483ef2a5b4b04745$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $483ef2a5b4b04745$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $483ef2a5b4b04745$export$185802fd694ee1f5);
const $483ef2a5b4b04745$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $483ef2a5b4b04745$var$hasPerformanceAPIAvailable = $483ef2a5b4b04745$var$isPerformanceAPIAvailable();
const $483ef2a5b4b04745$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $483ef2a5b4b04745$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $483ef2a5b4b04745$export$1a717feb4df1a945 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $483ef2a5b4b04745$export$de42547d395c8271 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $483ef2a5b4b04745$var$getMark = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $483ef2a5b4b04745$export$185802fd694ee1f5 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measure = $483ef2a5b4b04745$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $483ef2a5b4b04745$var$getMark(id, 'pending');
            const endMark = $483ef2a5b4b04745$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("1s0lY", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $47c640bee30204cc$export$4f2e371a667ad688);

var $7zaVw = parcelRequire("7zaVw");
const $47c640bee30204cc$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $7zaVw.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $7zaVw.messages)['status_change_update_error']
    }
};

});

parcelRegister("kf01E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a0af43cfe2e114d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aRoVz = parcelRequire("aRoVz");

var $hgsSZ = parcelRequire("hgsSZ");
const $9a0af43cfe2e114d$var$dropdownItemGroupStyles = null;
const $9a0af43cfe2e114d$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $bwpsq.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $5uXOq.createElement)((0, $hgsSZ.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $9a0af43cfe2e114d$export$2e2bcd8739ae039 = $9a0af43cfe2e114d$var$LozengeActionItemsGroup;

});
parcelRegister("hgsSZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $419e60cbfb62c454$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");
const $419e60cbfb62c454$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: appearance,
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    }));
};
var $419e60cbfb62c454$export$2e2bcd8739ae039 = $419e60cbfb62c454$var$LozengeActionItem;

});


parcelRegister("4Dg4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $afa61527cd4f792e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c8Oei = parcelRequire("c8Oei");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $afa61527cd4f792e$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw"
};
const $afa61527cd4f792e$var$triggerLozengeStyles = null;
const $afa61527cd4f792e$var$triggerButtonStyles = null;
const $afa61527cd4f792e$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
            appearance: appearance,
            isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? true : isBold,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                className: (0, $bwpsq.default)([
                    "_4cvr1h6o _1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        as: "span",
                        xcss: $afa61527cd4f792e$var$styles.chevronDown,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                            color: "currentColor",
                            label: "options",
                            LEGACY_size: "medium",
                            LEGACY_margin: "-4px -8px -4px -7px"
                        })
                    })
                ]
            })
        }), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        type: "button",
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $afa61527cd4f792e$export$2e2bcd8739ae039 = $afa61527cd4f792e$var$LozengeActionTrigger;

});



parcelRegister("77cM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a723b9f793426daa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l5Xsv = parcelRequire("l5Xsv");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $a723b9f793426daa$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $a723b9f793426daa$var$Media = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $a723b9f793426daa$export$2e2bcd8739ae039 = $a723b9f793426daa$var$Media;

});

parcelRegister("k39kU", function(module, exports) {

$parcel$export(module.exports, "default", () => $af078338fe34f0f5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $VSDnB = parcelRequire("VSDnB");

var $fpDmE = parcelRequire("fpDmE");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $af078338fe34f0f5$var$baseStyleOld = null;
const $af078338fe34f0f5$var$baseStyle = null;
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $af078338fe34f0f5$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text' })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            "--_1erfju8": (0, $lD23V.default)(maxLines)
        },
        children: (0, $fpDmE.getFormattedMessage)(message) || content
    });
};
var $af078338fe34f0f5$export$2e2bcd8739ae039 = $af078338fe34f0f5$var$Text;

});


parcelRegister("kDhrr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5972a7cc25546c87$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $77cM6 = parcelRequire("77cM6");
const $5972a7cc25546c87$var$Preview = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $8dVIb.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $77cM6.default), {
        ...rest,
        ...data
    });
};
var $5972a7cc25546c87$export$2e2bcd8739ae039 = $5972a7cc25546c87$var$Preview;

});

parcelRegister("kp8aU", function(module, exports) {

$parcel$export(module.exports, "default", () => $673e9555bded0d05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $k39kU = parcelRequire("k39kU");
const $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES = 3;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $673e9555bded0d05$var$snippetBaseStyleOld = null;
const $673e9555bded0d05$var$snippetBaseStyle = null;
const $673e9555bded0d05$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k39kU.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $673e9555bded0d05$export$2e2bcd8739ae039 = $673e9555bded0d05$var$SnippetElement;

});


parcelRegister("bubxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $66554651c27d9387$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $ldJSL = parcelRequire("ldJSL");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $bJeNF = parcelRequire("bJeNF");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $akF1x = parcelRequire("akF1x");

var $3Zm9O = parcelRequire("3Zm9O");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $66554651c27d9387$var$stylesOld = null;
const $66554651c27d9387$var$styles = null;
const $66554651c27d9387$var$renderActionItems = (items = [], size = (0, $8dVIb.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Zm9O.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $66554651c27d9387$var$ActionGroup = ({ items: items = [], size: size = (0, $8dVIb.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gKZoD.di)((0, $BLPHT.default));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fpDmE.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).more_actions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41j6v _dzc21h6o _1ilq1i6y",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ldJSL.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $66554651c27d9387$export$2e2bcd8739ae039 = $66554651c27d9387$var$ActionGroup;

});
parcelRegister("akF1x", function(module, exports) {

$parcel$export(module.exports, "filterActionItems", () => $8ba323b39584fd77$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $8ba323b39584fd77$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $8ba323b39584fd77$export$9678d3ca18bd7526);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $91tw3 = parcelRequire("91tw3");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $1BfaB = parcelRequire("1BfaB");
const $8ba323b39584fd77$export$f942619ce67b1a41 = {
    [(0, $8dVIb.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Location]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Preview]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).Priority]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Provider]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Snippet]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).State]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Title]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).VoteCount]: [
        'inline'
    ]
};
const $8ba323b39584fd77$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1;
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 0.5;
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $8ba323b39584fd77$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $bubxq.default);
const $8ba323b39584fd77$var$isElementDisplayValid = (name, display)=>{
    return $8ba323b39584fd77$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $8ba323b39584fd77$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $8ba323b39584fd77$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && ((0, $91tw3.isFlexibleUiElement)(node) || node.type === (0, $1BfaB.default));
const $8ba323b39584fd77$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $8dVIb.ActionName).DeleteAction:
            case (0, $8dVIb.ActionName).EditAction:
            case (0, $8dVIb.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $8dVIb.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $8ba323b39584fd77$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if ($8ba323b39584fd77$var$isElementOrElementGroup(child) || $8ba323b39584fd77$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $8ba323b39584fd77$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $eqoQu[name];
        const typedProps = props;
        if (Element && $8ba323b39584fd77$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $2OMIu.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$8ba323b39584fd77$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("1BfaB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed56962f49dee3a8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");
const $ed56962f49dee3a8$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $ed56962f49dee3a8$var$baseStyleBySizeOld = {
    xlarge: "_zulp147b _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    large: "_zulp1e9d _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    medium: "_zulpcxkx _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    small: "_zulppdf9 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v"
};
const $ed56962f49dee3a8$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $ed56962f49dee3a8$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $ed56962f49dee3a8$var$baseStyleOld = null;
const $ed56962f49dee3a8$var$baseStyles = null;
const $ed56962f49dee3a8$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $ed56962f49dee3a8$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $ed56962f49dee3a8$var$horizontalStyleBase = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $ed56962f49dee3a8$var$horizontalStyleByHeightOld = {
    xlarge: "_1e0ccj1k _102k1m1q",
    large: "_1e0ccj1k _102k1m1q",
    medium: "_1e0ccj1k _102k1k8s",
    small: "_1e0ccj1k _102k1k8s"
};
const $ed56962f49dee3a8$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $ed56962f49dee3a8$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $ed56962f49dee3a8$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $ed56962f49dee3a8$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $ed56962f49dee3a8$var$ElementGroup = ({ align: align = (0, $8dVIb.SmartLinkAlignment).Left, children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $8dVIb.SmartLinkWidth).FitToContent, position: position = (0, $8dVIb.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $8dVIb.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$baseStyleBySizeOld[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$baseStyleBySize[size],
            $ed56962f49dee3a8$var$baseStyleByDirection[direction],
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw _1ouwidpf _f6ju1ns9",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw",
            $ed56962f49dee3a8$var$alignmentStyleMap[align],
            "_1ul99by0",
            $ed56962f49dee3a8$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$horizontalStyleByHeightOld[size],
            isHorizontal && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $8dVIb.SmartLinkAlignment).Left && $ed56962f49dee3a8$var$gapStylesLeft[size],
            isHorizontal && align === (0, $8dVIb.SmartLinkAlignment).Right && $ed56962f49dee3a8$var$gapStylesRight[size],
            $ed56962f49dee3a8$var$positionStyle[position],
            className
        ]),
        children: (0, $akF1x.renderChildren)(children, size)
    });
};
var $ed56962f49dee3a8$export$2e2bcd8739ae039 = $ed56962f49dee3a8$var$ElementGroup;

});


parcelRegister("3Zm9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $70338cdeec0a99e7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jRHKj = parcelRequire("jRHKj");
const $70338cdeec0a99e7$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $jRHKj ? $jRHKj[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $70338cdeec0a99e7$export$2e2bcd8739ae039 = $70338cdeec0a99e7$var$ActionGroupItem;

});
parcelRegister("jRHKj", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("23vM5")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("96Kdz")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("fEhHT")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("g9G65")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("b6Mes")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("9mTP8")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("jep3X")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("ziZLe")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("5OUwn")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("faTeC")).default);

var $23vM5 = parcelRequire("23vM5");

var $96Kdz = parcelRequire("96Kdz");

var $fEhHT = parcelRequire("fEhHT");

var $g9G65 = parcelRequire("g9G65");

var $b6Mes = parcelRequire("b6Mes");

var $9mTP8 = parcelRequire("9mTP8");

var $jep3X = parcelRequire("jep3X");

var $ziZLe = parcelRequire("ziZLe");

var $5OUwn = parcelRequire("5OUwn");

var $faTeC = parcelRequire("faTeC");

});
parcelRegister("23vM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf7d27623ce3bf9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $f6kZQ = parcelRequire("f6kZQ");

var $kuVc8 = parcelRequire("kuVc8");

var $bhB72 = parcelRequire("bhB72");

var $1wpdl = parcelRequire("1wpdl");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $1bf7d27623ce3bf9$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1wpdl.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kuVc8.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6kZQ.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $1bf7d27623ce3bf9$export$2e2bcd8739ae039 = $1bf7d27623ce3bf9$var$Action;

});
parcelRegister("f6kZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ee32ab04698fad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $3dubP = parcelRequire("3dubP");

var $fpDmE = parcelRequire("fpDmE");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$IconOnlyLarge = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmall = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmallIconOnly = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmallNotIconOnly = null;
const $b3ee32ab04698fad$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $b3ee32ab04698fad$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $b3ee32ab04698fad$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $b3ee32ab04698fad$var$ActionButtonRefreshNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $5uXOq.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $krXdA.default), {
                appearance: $b3ee32ab04698fad$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $b3ee32ab04698fad$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                appearance: $b3ee32ab04698fad$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $b3ee32ab04698fad$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                appearance: $b3ee32ab04698fad$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                appearance: $b3ee32ab04698fad$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(ActionButton);
const $b3ee32ab04698fad$var$ActionButtonRefreshNewWithOverrideCss = (0, $3dubP.withOverrideCss)($b3ee32ab04698fad$var$ActionButtonRefreshNew);
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            size === (0, $8dVIb.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $8dVIb.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $8dVIb.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $8dVIb.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2rqOp.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $fpDmE.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $b3ee32ab04698fad$var$ActionButtonHideLegacyButton = (props)=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction && (0, $VSDnB.fg)('platform-linking-flexible-card-openness')) return /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonRefreshNewWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonNew, {
        ...props
    });
};
const $b3ee32ab04698fad$var$ActionButton = (props)=>{
    return (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonHideLegacyButton, {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonNew, {
        ...props
    });
};
var $b3ee32ab04698fad$export$2e2bcd8739ae039 = $b3ee32ab04698fad$var$ActionButton;

});

parcelRegister("kuVc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e656bda53d041540$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $kxcRq = parcelRequire("kxcRq");
const $e656bda53d041540$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $kxcRq.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $e656bda53d041540$export$2e2bcd8739ae039 = $e656bda53d041540$var$ActionDropdownItem;

});

parcelRegister("bhB72", function(module, exports) {

$parcel$export(module.exports, "default", () => $345d01659b23eb38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");
const $345d01659b23eb38$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $345d01659b23eb38$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $345d01659b23eb38$var$stackItemIconStylesOld = null;
const $345d01659b23eb38$var$stackItemIconStylesCompiled = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $345d01659b23eb38$var$iconStyleMap = {
    true: "_syaz2oi6",
    false: "_syazwdcn"
};
const $345d01659b23eb38$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap[$345d01659b23eb38$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $345d01659b23eb38$export$2e2bcd8739ae039 = $345d01659b23eb38$var$ActionIcon;

});

parcelRegister("1wpdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $5PILj = parcelRequire("5PILj");
const $c6ef8f3a6ac7d3ff$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5PILj.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5PILj.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039 = $c6ef8f3a6ac7d3ff$var$ActionStackItem;

});
parcelRegister("5PILj", function(module, exports) {

$parcel$export(module.exports, "default", () => $222d00bebc6cbf68$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");

var $eZJjh = parcelRequire("eZJjh");

var $fpDmE = parcelRequire("fpDmE");

var $bhB72 = parcelRequire("bhB72");
const $222d00bebc6cbf68$var$stylesOld = {
    button: "_kkk2n7od _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _irr3166n _1di61dty",
    content: "_11c8dcr7 _syaz1fxt"
};
const $222d00bebc6cbf68$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $222d00bebc6cbf68$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $fpDmE.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        xcss: (0, $3JT92.cx)(!(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$stylesOld.button, (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: (0, $3JT92.cx)(!(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$stylesOld.content, (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $222d00bebc6cbf68$export$2e2bcd8739ae039 = $222d00bebc6cbf68$var$ActionButton;

});



parcelRegister("96Kdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddac835e19e975e0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $84THj = parcelRequire("84THj");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $ddac835e19e975e0$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).delete
        }),
        ...props
    });
var $ddac835e19e975e0$export$2e2bcd8739ae039 = $ddac835e19e975e0$var$DeleteAction;

});

parcelRegister("fEhHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $23e1c92ea69f35be$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4ChK1 = parcelRequire("4ChK1");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $23e1c92ea69f35be$var$EditAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ChK1))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).edit
        }),
        ...props
    });
var $23e1c92ea69f35be$export$2e2bcd8739ae039 = $23e1c92ea69f35be$var$EditAction;

});
parcelRegister("4ChK1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
function $35c87913ec905242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35c87913ec905242$var$EditIcon = (props)=>/*#__PURE__*/ $35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
    }, props));
$35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("gsEeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfbe7921991bc4cb$var$EditIcon = (props)=>/*#__PURE__*/ $bfbe7921991bc4cb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $bfbe7921991bc4cb$var$_edit.default
    }));
$bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;

});



parcelRegister("g9G65", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fb79986052b65c1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $d4dv2 = parcelRequire("d4dv2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $4fb79986052b65c1$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).DownloadAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $7zaVw.messages).download_file : (0, $7zaVw.messages).download;
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).download_description : (0, $7zaVw.messages).download;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d4dv2))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $4fb79986052b65c1$export$2e2bcd8739ae039 = $4fb79986052b65c1$var$DownloadAction;

});
parcelRegister("d4dv2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::647640fe09afef5813e2888b2ce1f074>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98361ed174bfbb2b$var$_react = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $98361ed174bfbb2b$var$_download = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("EOGIN")));

var $98361ed174bfbb2b$var$_download2 = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5krT5")));
function $98361ed174bfbb2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98361ed174bfbb2b$var$DownloadIcon = (props)=>/*#__PURE__*/ $98361ed174bfbb2b$var$_react.default.createElement($98361ed174bfbb2b$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $98361ed174bfbb2b$var$_download2.default
    }, props));
$98361ed174bfbb2b$var$DownloadIcon.Name = 'DownloadIconMigration';
var $98361ed174bfbb2b$var$_default = module.exports.default = $98361ed174bfbb2b$var$DownloadIcon;

});
parcelRegister("EOGIN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07ab0e2228a1635e$var$_react = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $07ab0e2228a1635e$var$_baseNew = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $07ab0e2228a1635e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07ab0e2228a1635e$var$DownloadIcon = (props)=>/*#__PURE__*/ $07ab0e2228a1635e$var$_react.default.createElement($07ab0e2228a1635e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$07ab0e2228a1635e$var$DownloadIcon.displayName = 'DownloadIcon';
var $07ab0e2228a1635e$var$_default = module.exports.default = $07ab0e2228a1635e$var$DownloadIcon;

});

parcelRegister("5krT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e1473e49ea22b68$var$_react = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3e1473e49ea22b68$var$_download = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("EOGIN")));
function $3e1473e49ea22b68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e1473e49ea22b68$var$DownloadIcon = (props)=>/*#__PURE__*/ $3e1473e49ea22b68$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $3e1473e49ea22b68$var$_download.default
    }));
$3e1473e49ea22b68$var$DownloadIcon.displayName = 'DownloadIcon';
var $3e1473e49ea22b68$var$_default = module.exports.default = $3e1473e49ea22b68$var$DownloadIcon;

});



parcelRegister("b6Mes", function(module, exports) {

$parcel$export(module.exports, "default", () => $879133cabfb6e190$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $3xnBw = parcelRequire("3xnBw");

var $itef5 = parcelRequire("itef5");


const $879133cabfb6e190$var$importIconMapper = {
    goal: ()=>(parcelRequire("82OF2")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("9yaZS")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $879133cabfb6e190$var$getIcon = (stackIconType)=>{
    const importFn = $879133cabfb6e190$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fpDmE.importIcon)(importFn);
};
const $879133cabfb6e190$var$FollowAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $7zaVw.messages).follow : (0, $7zaVw.messages).unfollow;
    const projectMessage = value ? (0, $7zaVw.messages).follow_project : (0, $7zaVw.messages).unfollow_project;
    const goalMessage = value ? (0, $7zaVw.messages).follow_goal : (0, $7zaVw.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $7zaVw.messages).follow_project_description : (0, $7zaVw.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $7zaVw.messages).follow_goal_description : (0, $7zaVw.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $879133cabfb6e190$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $itef5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3xnBw.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $879133cabfb6e190$export$2e2bcd8739ae039 = $879133cabfb6e190$var$FollowAction;

});
parcelRegister("3xnBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $35d557ed1ef6412d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $69hr0 = parcelRequire("69hr0");

var $23vM5 = parcelRequire("23vM5");
const $35d557ed1ef6412d$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const invoke = (0, $3q2sI.default)();
    const reload = (0, $f22ja.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $69hr0.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $euMlu.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $35d557ed1ef6412d$export$2e2bcd8739ae039 = $35d557ed1ef6412d$var$ServerAction;

});
parcelRegister("69hr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d791805237a266$export$2e2bcd8739ae039);
const $22d791805237a266$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $22d791805237a266$export$2e2bcd8739ae039 = $22d791805237a266$var$createInvokeRequest;

});


parcelRegister("itef5", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $d31a392ae92ce299$export$49248678d3914625);

var $7zaVw = parcelRequire("7zaVw");
const $d31a392ae92ce299$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $7zaVw.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $7zaVw.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $7zaVw.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $7zaVw.messages).unfollow_goal_error;
    return (0, $7zaVw.messages).generic_error_message;
};

});

parcelRegister("82OF2", function(module, exports) {

let $5db5ced4f0000848$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5db5ced4f0000848$var$load("h2MrD"),
    $5db5ced4f0000848$var$load("bYT2S"),
    $5db5ced4f0000848$var$load("ftS7u")
]).then(()=>parcelRequire('5UxRR'));

});

parcelRegister("9yaZS", function(module, exports) {

let $01cb5a17f25affbd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $01cb5a17f25affbd$var$load("h2MrD"),
    $01cb5a17f25affbd$var$load("bYT2S"),
    $01cb5a17f25affbd$var$load("3uQsu")
]).then(()=>parcelRequire('gsEJ1'));

});


parcelRegister("9mTP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ea9170f77974c10$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $5JpK2 = parcelRequire("5JpK2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $3ea9170f77974c10$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).PreviewAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).preview_description : (0, $7zaVw.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).preview_improved
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $3ea9170f77974c10$export$2e2bcd8739ae039 = $3ea9170f77974c10$var$PreviewAction;

});
parcelRegister("5JpK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));

var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
    }, props));
$42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;

});


parcelRegister("jep3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1e0763b6a84021$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jOyH3 = parcelRequire("jOyH3");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $0d1e0763b6a84021$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_url_to_clipboard);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $7zaVw.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $0d1e0763b6a84021$export$2e2bcd8739ae039 = $0d1e0763b6a84021$var$CopyLinkAction;

});

parcelRegister("ziZLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b53b1e1aa704061$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $dgRei = parcelRequire("dgRei");
const $8b53b1e1aa704061$var$AISummaryAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dgRei.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $8b53b1e1aa704061$export$2e2bcd8739ae039 = $8b53b1e1aa704061$var$AISummaryAction;

});
parcelRegister("dgRei", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $a6e4dbdfe418b2c1$export$8eed96bc6d982595);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $1MeuC = parcelRequire("1MeuC");

var $8UCLX = parcelRequire("8UCLX");

var $jdA9V = parcelRequire("jdA9V");
const $a6e4dbdfe418b2c1$export$8eed96bc6d982595 = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $1MeuC.default)(url);
    (0, $5uXOq.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdA9V.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UCLX.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("1MeuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $27e30e18347ce2a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hWyvy = parcelRequire("hWyvy");
var $8UXrm = parcelRequire("8UXrm");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $hjhAz = parcelRequire("hjhAz");

var $kR87P = parcelRequire("kR87P");

var $anB5s = parcelRequire("anB5s");
const $27e30e18347ce2a0$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $27e30e18347ce2a0$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $anB5s.useAISummaryConfig)();
    const cardState = (0, $hjhAz.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $hWyvy.extractAri)(data);
    const dataUrl = data && (0, $8UXrm.extractLink)(data) || '';
    const onStart = (0, $5uXOq.useCallback)((id)=>{
        (0, $1VPdD.startUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $5uXOq.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1VPdD.succeedUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $5uXOq.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1VPdD.failUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $kR87P.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $27e30e18347ce2a0$export$2e2bcd8739ae039 = $27e30e18347ce2a0$var$useAISummaryAction;

});
parcelRegister("hWyvy", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $e72cc95d6d37b739$export$be18a6294fd426ec);
const $e72cc95d6d37b739$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("kR87P", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $c5395471ca862cc2$export$becd8f2eba1bbd96);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $SrCME = parcelRequire("SrCME");

var $561ku = parcelRequire("561ku");
const $c5395471ca862cc2$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $5uXOq.useState)((0, $561ku.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $561ku.AISummariesStore).get(url)) (0, $561ku.AISummariesStore).set(url, new (0, $SrCME.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $561ku.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $561ku.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("SrCME", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $ad05438f1e08870b$export$73e4b807d5bd74b6);

var $7Jxgt = parcelRequire("7Jxgt");

var $itO4f = parcelRequire("itO4f");

var $9AA7J = parcelRequire("9AA7J");

var $c0Zwh = parcelRequire("c0Zwh");

var $ghXNq = parcelRequire("ghXNq");
class $ad05438f1e08870b$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $itO4f.getBaseUrl)(envKey);
                return (0, $ghXNq.addPath)(baseUrl, path);
            }
            return (0, $ghXNq.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $9AA7J.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $ghXNq.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $c0Zwh.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $c0Zwh.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("9AA7J", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $27dc203987154036$export$e45226161c660403);

var $ghXNq = parcelRequire("ghXNq");
async function* $27dc203987154036$export$e45226161c660403(response) {
    const reader = (0, $ghXNq.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("ghXNq", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $6c9c387ba5dd9d5b$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $6c9c387ba5dd9d5b$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $6c9c387ba5dd9d5b$export$ff2962de2b2c930f);
const $6c9c387ba5dd9d5b$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $6c9c387ba5dd9d5b$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $6c9c387ba5dd9d5b$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $6c9c387ba5dd9d5b$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $6c9c387ba5dd9d5b$export$ff2962de2b2c930f = (product)=>{
    if ($6c9c387ba5dd9d5b$var$isJiraProduct(product)) return $6c9c387ba5dd9d5b$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("c0Zwh", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $0e5f8d5a8019ed33$export$fcec967a4b7ebd84);
class $0e5f8d5a8019ed33$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $0e5f8d5a8019ed33$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("561ku", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $cc472589618fd980$export$6979339b6d41707e);

var $iwKVT = parcelRequire("iwKVT");
const $cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE = 100;
const $cc472589618fd980$export$6979339b6d41707e = new (0, $iwKVT.LRUMap)($cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("anB5s", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $cd0a62b074a064ce$export$4480af2c00aa7ebe);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $cd0a62b074a064ce$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $051X7.useSmartLinkContext)();
    return (0, $5uXOq.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("8UCLX", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $a2971ac1720627ee$export$75a19de44af58722);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jps85 = parcelRequire("jps85");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $8z1HA = parcelRequire("8z1HA");

var $23vM5 = parcelRequire("23vM5");

var $blyr7 = parcelRequire("blyr7");
function $a2971ac1720627ee$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onCompleted = (0, $5uXOq.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $blyr7.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $8z1HA.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("jps85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2162c0618e136c6$var$_react = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e2162c0618e136c6$var$_baseNew = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e2162c0618e136c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2162c0618e136c6$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $e2162c0618e136c6$var$_react.default.createElement($e2162c0618e136c6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$e2162c0618e136c6$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $e2162c0618e136c6$var$_default = module.exports.default = $e2162c0618e136c6$var$AtlassianIntelligenceIcon;

});

parcelRegister("8z1HA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8c2f1acb4b6b88$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $7f8c2f1acb4b6b88$var$AiIcon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $7f8c2f1acb4b6b88$export$2e2bcd8739ae039 = $7f8c2f1acb4b6b88$var$AiIcon;

});

parcelRegister("blyr7", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $2b1346f84062e88d$export$82f46aa4e6535a45);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $cnaAy = parcelRequire("cnaAy");

var $RbANO = parcelRequire("RbANO");

var $1r4gF = parcelRequire("1r4gF");
const $2b1346f84062e88d$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $cnaAy.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RbANO.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1r4gF.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("cnaAy", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $3339f41fc1b0dac1$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $3339f41fc1b0dac1$export$cd2e891d7f87074d);

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $3339f41fc1b0dac1$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $3339f41fc1b0dac1$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $8dVIb.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $7zaVw.messages).ai_summary_error_generic,
                url: (0, $8dVIb.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("RbANO", function(module, exports) {

$parcel$export(module.exports, "default", () => $402c39c7523f0dd1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $402c39c7523f0dd1$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $402c39c7523f0dd1$export$2e2bcd8739ae039 = $402c39c7523f0dd1$var$AIEventErrorViewed;

});

parcelRegister("1r4gF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8f369a3b340dfb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");
const $ff8f369a3b340dfb$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: (0, $8dVIb.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $ff8f369a3b340dfb$export$2e2bcd8739ae039 = $ff8f369a3b340dfb$var$AILearnMoreAnchor;

});



parcelRegister("jdA9V", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $2e1357a85e616794$export$cfa1d3eed9a61059);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $3Fq5M = parcelRequire("3Fq5M");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
function $2e1357a85e616794$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $5uXOq.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $7zaVw.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_summary_action_description),
        ...props
    });
}

});



parcelRegister("5OUwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd2a7343c5a2622$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $4ldhu = parcelRequire("4ldhu");

var $dS3PR = parcelRequire("dS3PR");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $e5vwM = parcelRequire("e5vwM");

var $3Lbo8 = parcelRequire("3Lbo8");

const $9fd2a7343c5a2622$var$AutomationModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("EjrMr")));
const $9fd2a7343c5a2622$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $8dVIb.ActionName).AutomationAction];
    const automationActionOnClick = (0, $5uXOq.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $3Lbo8.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($9fd2a7343c5a2622$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $7zaVw.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $e5vwM.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $9fd2a7343c5a2622$export$2e2bcd8739ae039 = $9fd2a7343c5a2622$var$AutomationAction;

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("7HAq8", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $bc735e1cde43eb76$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $lnPiq = parcelRequire("lnPiq");
const $bc735e1cde43eb76$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $bc735e1cde43eb76$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($bc735e1cde43eb76$var$FALLBACK_API);
const $bc735e1cde43eb76$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    const api = (0, $5uXOq.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnPiq.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $5uXOq.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $5uXOq.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8 = ()=>(0, $5uXOq.useContext)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c);

});
parcelRegister("lnPiq", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $a203465a8c9e0684$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $a203465a8c9e0684$var$styles = null;
const $a203465a8c9e0684$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onClick: onClick,
        className: (0, $bwpsq.default)([
            "_c71lidpf _p12fidpf _kqswstnw"
        ]),
        children: children
    });
};

});


parcelRegister("e5vwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $23884530c116b98b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $23884530c116b98b$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $23884530c116b98b$export$2e2bcd8739ae039 = $23884530c116b98b$var$AutomationManualTriggersGlyph;

});

parcelRegister("3Lbo8", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $6b74a4060fa13021$export$93e707b363eaf5c8);

var $7zaVw = parcelRequire("7zaVw");
const $6b74a4060fa13021$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $7zaVw.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $7zaVw.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("EjrMr", function(module, exports) {

let $0792d252ffbcd5aa$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0792d252ffbcd5aa$var$load("hPzOn"),
    $0792d252ffbcd5aa$var$load("h2MrD"),
    $0792d252ffbcd5aa$var$load("bYT2S"),
    $0792d252ffbcd5aa$var$load("lchYl")
]).then(()=>parcelRequire('1Rjyb'));

});


parcelRegister("faTeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b95acafe5e8a7ba5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $k98Kd = parcelRequire("k98Kd");

const $b95acafe5e8a7ba5$var$RelatedLinksModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("19m52")));
const $b95acafe5e8a7ba5$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($b95acafe5e8a7ba5$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? (0, $7zaVw.messages).related_links_view_related_links : (0, $7zaVw.messages).related_links_view_related_urls
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k98Kd.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $b95acafe5e8a7ba5$export$2e2bcd8739ae039 = $b95acafe5e8a7ba5$var$ViewRelatedLinksAction;

});
parcelRegister("k98Kd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9aac1bc71ae3e1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hyKRO = parcelRequire("hyKRO");

var $ehOs2 = parcelRequire("ehOs2");

var $VSDnB = parcelRequire("VSDnB");
const $7c9aac1bc71ae3e1$var$rotateSvg = null;
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon = ()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_t9ec1sub _1e0c1o8l"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ehOs2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        })
    });
var $7c9aac1bc71ae3e1$export$2e2bcd8739ae039 = $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon;

});
parcelRegister("ehOs2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::460873555b00dc694a7c27133071dd5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a669c9c7dda1a2bd$var$_react = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a669c9c7dda1a2bd$var$_childIssues = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("a5U1O")));

var $a669c9c7dda1a2bd$var$_childIssues2 = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("hxodJ")));
function $a669c9c7dda1a2bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChildIssuesIcon.
 * This component is ChildIssuesIcon, with `UNSAFE_fallbackIcon` set to "ChildIssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a669c9c7dda1a2bd$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $a669c9c7dda1a2bd$var$_react.default.createElement($a669c9c7dda1a2bd$var$_childIssues.default, Object.assign({
        LEGACY_fallbackIcon: $a669c9c7dda1a2bd$var$_childIssues2.default
    }, props));
$a669c9c7dda1a2bd$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
var $a669c9c7dda1a2bd$var$_default = module.exports.default = $a669c9c7dda1a2bd$var$ChildIssuesIcon;

});
parcelRegister("a5U1O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::359c101bebeaae075dd3e3e9a50caec7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7595d510a7cf11ee$var$_react = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7595d510a7cf11ee$var$_baseNew = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7595d510a7cf11ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7595d510a7cf11ee$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $7595d510a7cf11ee$var$_react.default.createElement($7595d510a7cf11ee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 4.5V1H1v10a2 2 0 0 0 2 2h4v.75c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-5.5c-.69 0-1.25.56-1.25 1.25v.75H3a.5.5 0 0 1-.5-.5V6H7v.75C7 7.44 7.56 8 8.25 8h5.5C14.44 8 15 7.44 15 6.75v-3c0-.69-.56-1.25-1.25-1.25h-5.5C7.56 2.5 7 3.06 7 3.75v.75zm6-.5v2.5h5V4zm0 7v2.5h5V11z" clip-rule="evenodd"/>`
    }, props));
$7595d510a7cf11ee$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $7595d510a7cf11ee$var$_default = module.exports.default = $7595d510a7cf11ee$var$ChildIssuesIcon;

});

parcelRegister("hxodJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc484e6d94653edf$var$_react = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cc484e6d94653edf$var$_childIssues = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("a5U1O")));
function $cc484e6d94653edf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc484e6d94653edf$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $cc484e6d94653edf$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $cc484e6d94653edf$var$_childIssues.default
    }));
$cc484e6d94653edf$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $cc484e6d94653edf$var$_default = module.exports.default = $cc484e6d94653edf$var$ChildIssuesIcon;

});



parcelRegister("19m52", function(module, exports) {

let $0d67c25d523d11e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0d67c25d523d11e2$var$load("dXU8n").then(()=>parcelRequire('14MtF'));

});





parcelRegister("dghu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a6d91fb5d77548$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $96a6d91fb5d77548$var$BaseBlockStylesOld = null;
const $96a6d91fb5d77548$var$baseBlockStyles = null;
const $96a6d91fb5d77548$var$highlightRemoveStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $96a6d91fb5d77548$var$gapsStylesOld = {
    xlarge: "_zulp1k92 _1ljq1k92",
    large: "_zulp1j6v _1ljq1j6v",
    medium: "_zulp1kwk _1ljq1kwk",
    small: "_zulp6mu8 _1ljq6mu8"
};
const $96a6d91fb5d77548$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $96a6d91fb5d77548$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $96a6d91fb5d77548$var$Block = ({ children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style })=>{
    (0, $5uXOq.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _vwz41j6v _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1ouwidpf _f6ju1ns9 _1uzp1mp2 _ytq1bjq5 _a7e8uxlv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $96a6d91fb5d77548$var$directionStyles[direction],
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $96a6d91fb5d77548$var$gapsStylesOld[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $96a6d91fb5d77548$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: (0, $akF1x.renderChildren)(children, size)
    });
};
var $96a6d91fb5d77548$export$2e2bcd8739ae039 = $96a6d91fb5d77548$var$Block;

});



parcelRegister("gg6Qm", function(module, exports) {

$parcel$export(module.exports, "default", () => $61dcf60a0013442f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $61dcf60a0013442f$var$DEFAULT_MAX_LINES = 2;
const $61dcf60a0013442f$var$MAXIMUM_MAX_LINES = 2;
const $61dcf60a0013442f$var$MINIMUM_MAX_LINES = 1;
const $61dcf60a0013442f$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $61dcf60a0013442f$var$sizeStylesOld = {
    xlarge: "_vwz41m1q _102k1k7u",
    large: "_vwz41m1q _102k1k7u",
    medium: "_vwz41k8s _102k1wto",
    small: "_vwz41k8s _102k1wto"
};
const $61dcf60a0013442f$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $61dcf60a0013442f$var$getMaxLines = (maxLines)=>{
    if (maxLines > $61dcf60a0013442f$var$MAXIMUM_MAX_LINES) return $61dcf60a0013442f$var$DEFAULT_MAX_LINES;
    if (maxLines < $61dcf60a0013442f$var$MINIMUM_MAX_LINES) return $61dcf60a0013442f$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $61dcf60a0013442f$var$MetadataBlock = ({ maxLines: maxLines = $61dcf60a0013442f$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $akF1x.renderElementItems)(primary);
    const secondaryElements = (0, $akF1x.renderElementItems)(secondary);
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const maxLinesTotal = $61dcf60a0013442f$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            primaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Left,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStylesOld[size],
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStyles[size]
                ]),
                children: primaryElements
            }),
            secondaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStylesOld[size],
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStyles[size]
                ]),
                children: secondaryElements
            })
        ]
    });
};
var $61dcf60a0013442f$export$2e2bcd8739ae039 = $61dcf60a0013442f$var$MetadataBlock;

});

parcelRegister("hYQw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $61b44b31e2da1312$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $cElbi = parcelRequire("cElbi");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $61b44b31e2da1312$var$PreviewBlock = ({ status: // eslint-disable-next-line @typescript-eslint/no-unused-vars
status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cElbi.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $61b44b31e2da1312$export$2e2bcd8739ae039 = $61b44b31e2da1312$var$PreviewBlock;

});
parcelRegister("cElbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $64981f7edc74268b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $kDhrr = parcelRequire("kDhrr");

var $dghu0 = parcelRequire("dghu0");
const $64981f7edc74268b$var$previewBlockStyleCommon = null;
const $64981f7edc74268b$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $64981f7edc74268b$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $5uXOq.useState)(style ?? {});
    const updateStyles = (0, $5uXOq.useCallback)(()=>{
        if (placement === (0, $8dVIb.MediaPlacement).Left || placement === (0, $8dVIb.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? '0px' : '0rem' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $8dVIb.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $8dVIb.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $5uXOq.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDhrr.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $64981f7edc74268b$export$2e2bcd8739ae039 = $64981f7edc74268b$var$PreviewBlockResolvedView;

});


parcelRegister("1JaZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c880264dd5ccb40b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $kp8aU = parcelRequire("kp8aU");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
const $c880264dd5ccb40b$var$DEFAULT_MAX_LINES = 3;
const $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES = 6;
const $c880264dd5ccb40b$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $c880264dd5ccb40b$var$SnippetBlock = ({ maxLines: maxLines = $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $fpDmE.getMaxLines)(maxLines, $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES, $c880264dd5ccb40b$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kp8aU.default), {
            maxLines: snippetMaxLines,
            content: text
        })
    });
};
var $c880264dd5ccb40b$export$2e2bcd8739ae039 = $c880264dd5ccb40b$var$SnippetBlock;

});

parcelRegister("buvhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b66054384f48ec$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $fkxMX = parcelRequire("fkxMX");

var $bXy5i = parcelRequire("bXy5i");

var $jHa2h = parcelRequire("jHa2h");
const $93b66054384f48ec$var$actionStyles = null;
const $93b66054384f48ec$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Pending:
        case (0, $8dVIb.SmartLinkStatus).Resolving:
            return 0, $jHa2h.default;
        case (0, $8dVIb.SmartLinkStatus).Resolved:
            return 0, $bXy5i.default;
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).NotFound:
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return 0, $fkxMX.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $93b66054384f48ec$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, ...props })=>{
    if (hideRetry && props.retry) delete props.retry;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $93b66054384f48ec$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        icon: icon,
        size: props.size,
        theme: theme
    });
};
var $93b66054384f48ec$export$2e2bcd8739ae039 = $93b66054384f48ec$var$TitleBlock;

});
parcelRegister("fkxMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbea6814ca213c7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $dcbea6814ca213c7$var$TitleBlockErroredView = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const hasAction = onClick !== undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position
            }),
            title,
            descriptor && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    onClick: onClick,
                    testId: `${testId}-errored-view-message`,
                    tabIndex: hasAction ? 0 : -1,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...descriptor,
                        values: values
                    })
                })
            }),
            actionGroup
        ]
    });
};
var $dcbea6814ca213c7$export$2e2bcd8739ae039 = $dcbea6814ca213c7$var$TitleBlockErroredView;

});

parcelRegister("bXy5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2967317da51f9f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $e2967317da51f9f7$var$style = null;
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $e2967317da51f9f7$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $akF1x.renderElementItems)(metadata);
    const subtitleElements = (0, $akF1x.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Vertical,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $bwpsq.default)([
                    "_zulp1b66"
                ]),
                children: [
                    title,
                    subtitleElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $8dVIb.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $e2967317da51f9f7$export$2e2bcd8739ae039 = $e2967317da51f9f7$var$TitleBlockResolvedView;

});

parcelRegister("jHa2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $045d1b1e49cae759$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $gU02S = parcelRequire("gU02S");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
const $045d1b1e49cae759$var$iconStyle = {
    xlarge: "_16jlidpf _1o9zidpf _i0dl1wug _4t3iviql _1tkeviql _c71lviql _1bsbviql _1ul9viql _p12fviql _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7viql _1xjxviql _1752viql _qci8viql _15izviql _erubviql _19l3viql _1pr2viql _1u5tviql _mezjviql _e2ooviql _w8l5viql _1rg2viql _q7cvviql _xwbjviql _rtysviql _b8nkviql _4x20viql",
    large: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    medium: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    small: "_16jlidpf _1o9zidpf _i0dl1wug _4t3ioqnp _1tkeoqnp _c71loqnp _1bsboqnp _1ul9oqnp _p12foqnp _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7oqnp _1xjxoqnp _1752oqnp _qci8oqnp _15izoqnp _eruboqnp _19l3oqnp _1pr2oqnp _1u5toqnp _mezjoqnp _e2oooqnp _w8l5oqnp _1rg2oqnp _q7cvoqnp _xwbjoqnp _rtysoqnp _b8nkoqnp _4x20oqnp"
};
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $045d1b1e49cae759$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) {
        const iconWidth = (0, $fpDmE.getIconWidthNew)(size);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
            ...blockProps,
            testId: `${testId}-resolving-view`,
            children: [
                !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    style: {
                        width: iconWidth,
                        height: iconWidth
                    },
                    "data-testid": `${testId}-icon`,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonNew), {
                        width: iconWidth,
                        height: iconWidth,
                        testId: `${testId}-icon-loading`
                    })
                }),
                title,
                actionGroup
            ]
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": `${testId}-icon`,
                className: (0, $bwpsq.default)([
                    $045d1b1e49cae759$var$iconStyle[size]
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonOld), {
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $045d1b1e49cae759$export$2e2bcd8739ae039 = $045d1b1e49cae759$var$TitleBlockResolvingView;

});


parcelRegister("1qDIM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dff75b4d7cc06d3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $4tgi5 = parcelRequire("4tgi5");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $5dff75b4d7cc06d3$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4tgi5.default), {
        ...props,
        testId: testId,
        url: actionData.url
    });
};
var $5dff75b4d7cc06d3$export$2e2bcd8739ae039 = $5dff75b4d7cc06d3$var$AISummaryBlock;

});
parcelRegister("4tgi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $413bb2fab5c71807$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $8dVIb = parcelRequire("8dVIb");

var $1MeuC = parcelRequire("1MeuC");

var $bHeMs = parcelRequire("bHeMs");

var $aBTst = parcelRequire("aBTst");

var $dghu0 = parcelRequire("dghu0");

var $adeuB = parcelRequire("adeuB");
const $413bb2fab5c71807$var$styles = null;
const $413bb2fab5c71807$var$AISummaryBlockResolvedView = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default), (0, $bHeMs.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $1MeuC.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        direction: (0, $8dVIb.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adeuB.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bHeMs.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $413bb2fab5c71807$export$2e2bcd8739ae039 = $413bb2fab5c71807$var$AISummaryBlockResolvedView;

});
parcelRegister("bHeMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea67ef8b17402f34$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $flpap = parcelRequire("flpap");

var $VSDnB = parcelRequire("VSDnB");

var $aRS1S = parcelRequire("aRS1S");
const $ea67ef8b17402f34$var$AISummaryCSSStyles = null;
const $ea67ef8b17402f34$var$baseStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $ea67ef8b17402f34$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $flpap.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $aRS1S.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $ea67ef8b17402f34$export$2e2bcd8739ae039 = $ea67ef8b17402f34$var$AISummary;

});
parcelRegister("flpap", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2bc56c6c0b4e02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b2bc56c6c0b4e02e$var$t() {
    return $b2bc56c6c0b4e02e$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $b2bc56c6c0b4e02e$var$t.apply(this, arguments);
}
const $b2bc56c6c0b4e02e$var$n = [
    "children",
    "options"
], $b2bc56c6c0b4e02e$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $b2bc56c6c0b4e02e$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($b2bc56c6c0b4e02e$var$i || ($b2bc56c6c0b4e02e$var$i = {}));
const $b2bc56c6c0b4e02e$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $b2bc56c6c0b4e02e$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $b2bc56c6c0b4e02e$var$o = [
    "style",
    "script"
], $b2bc56c6c0b4e02e$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b2bc56c6c0b4e02e$var$s = /mailto:/i, $b2bc56c6c0b4e02e$var$d = /\n{2,}$/, $b2bc56c6c0b4e02e$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $b2bc56c6c0b4e02e$var$u = /^ *> ?/gm, $b2bc56c6c0b4e02e$var$f = /^ {2,}\n/, $b2bc56c6c0b4e02e$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $b2bc56c6c0b4e02e$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b2bc56c6c0b4e02e$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $b2bc56c6c0b4e02e$var$k = /^(?:\n *)*\n/, $b2bc56c6c0b4e02e$var$x = /\r\n?/g, $b2bc56c6c0b4e02e$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $b2bc56c6c0b4e02e$var$v = /^\[\^([^\]]+)]/, $b2bc56c6c0b4e02e$var$S = /\f/g, $b2bc56c6c0b4e02e$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b2bc56c6c0b4e02e$var$C = /^\s*?\[(x|\s)\]/, $b2bc56c6c0b4e02e$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $b2bc56c6c0b4e02e$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b2bc56c6c0b4e02e$var$T = /^<!--[\s\S]*?(?:-->)/, $b2bc56c6c0b4e02e$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b2bc56c6c0b4e02e$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b2bc56c6c0b4e02e$var$M = /^\{.*\}$/, $b2bc56c6c0b4e02e$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b2bc56c6c0b4e02e$var$I = /^<([^ >]+@[^ >]+)>/, $b2bc56c6c0b4e02e$var$U = /^<([^ >]+:\/[^ >]+)>/, $b2bc56c6c0b4e02e$var$D = /-([a-z])?/gi, $b2bc56c6c0b4e02e$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $b2bc56c6c0b4e02e$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b2bc56c6c0b4e02e$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b2bc56c6c0b4e02e$var$_ = /\t/g, $b2bc56c6c0b4e02e$var$G = /(^ *\||\| *$)/g, $b2bc56c6c0b4e02e$var$W = /^ *:-+: *$/, $b2bc56c6c0b4e02e$var$Z = /^ *:-+ *$/, $b2bc56c6c0b4e02e$var$q = /^ *-+: *$/, $b2bc56c6c0b4e02e$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $b2bc56c6c0b4e02e$var$V = new RegExp(`^([*_])\\1${$b2bc56c6c0b4e02e$var$Q}\\1\\1(?!\\1)`), $b2bc56c6c0b4e02e$var$X = new RegExp(`^([*_])${$b2bc56c6c0b4e02e$var$Q}\\1(?!\\1|\\w)`), $b2bc56c6c0b4e02e$var$J = new RegExp(`^==${$b2bc56c6c0b4e02e$var$Q}==`), $b2bc56c6c0b4e02e$var$K = new RegExp(`^~~${$b2bc56c6c0b4e02e$var$Q}~~`), $b2bc56c6c0b4e02e$var$Y = /^\\([^0-9A-Za-z\s])/, $b2bc56c6c0b4e02e$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $b2bc56c6c0b4e02e$var$te = /^\n+/, $b2bc56c6c0b4e02e$var$ne = /^([ \t]*)/, $b2bc56c6c0b4e02e$var$re = /\\([^\\])/g, $b2bc56c6c0b4e02e$var$ie = / *\n+$/, $b2bc56c6c0b4e02e$var$le = /(?:^|\n)( *)$/, $b2bc56c6c0b4e02e$var$ae = "(?:\\d+\\.)", $b2bc56c6c0b4e02e$var$oe = "(?:[*+-])";
function $b2bc56c6c0b4e02e$var$ce(e) {
    return "( *)(" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + ") +";
}
const $b2bc56c6c0b4e02e$var$se = $b2bc56c6c0b4e02e$var$ce(1), $b2bc56c6c0b4e02e$var$de = $b2bc56c6c0b4e02e$var$ce(2);
function $b2bc56c6c0b4e02e$var$pe(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de));
}
const $b2bc56c6c0b4e02e$var$ue = $b2bc56c6c0b4e02e$var$pe(1), $b2bc56c6c0b4e02e$var$fe = $b2bc56c6c0b4e02e$var$pe(2);
function $b2bc56c6c0b4e02e$var$he(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $b2bc56c6c0b4e02e$var$me = $b2bc56c6c0b4e02e$var$he(1), $b2bc56c6c0b4e02e$var$ge = $b2bc56c6c0b4e02e$var$he(2);
function $b2bc56c6c0b4e02e$var$ye(e) {
    const t = 1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $b2bc56c6c0b4e02e$var$ke = $b2bc56c6c0b4e02e$var$ye(1), $b2bc56c6c0b4e02e$var$xe = $b2bc56c6c0b4e02e$var$ye(2);
function $b2bc56c6c0b4e02e$var$be(e, t) {
    const n = 1 === t, i = n ? $b2bc56c6c0b4e02e$var$ke : $b2bc56c6c0b4e02e$var$xe, l = n ? $b2bc56c6c0b4e02e$var$me : $b2bc56c6c0b4e02e$var$ge, a = n ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$fe;
    return {
        match (e, t) {
            const n = $b2bc56c6c0b4e02e$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($b2bc56c6c0b4e02e$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($b2bc56c6c0b4e02e$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($b2bc56c6c0b4e02e$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $b2bc56c6c0b4e02e$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $b2bc56c6c0b4e02e$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$Ee = [
    $b2bc56c6c0b4e02e$var$p,
    $b2bc56c6c0b4e02e$var$m,
    $b2bc56c6c0b4e02e$var$g,
    $b2bc56c6c0b4e02e$var$$,
    $b2bc56c6c0b4e02e$var$z,
    $b2bc56c6c0b4e02e$var$w,
    $b2bc56c6c0b4e02e$var$T,
    $b2bc56c6c0b4e02e$var$j,
    $b2bc56c6c0b4e02e$var$me,
    $b2bc56c6c0b4e02e$var$ke,
    $b2bc56c6c0b4e02e$var$ge,
    $b2bc56c6c0b4e02e$var$xe
], $b2bc56c6c0b4e02e$var$Ce = [
    ...$b2bc56c6c0b4e02e$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $b2bc56c6c0b4e02e$var$L,
    $b2bc56c6c0b4e02e$var$B
];
function $b2bc56c6c0b4e02e$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $b2bc56c6c0b4e02e$var$we(e) {
    return $b2bc56c6c0b4e02e$var$q.test(e) ? "right" : $b2bc56c6c0b4e02e$var$W.test(e) ? "center" : $b2bc56c6c0b4e02e$var$Z.test(e) ? "left" : null;
}
function $b2bc56c6c0b4e02e$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $b2bc56c6c0b4e02e$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($b2bc56c6c0b4e02e$var$G, "").split("|").map($b2bc56c6c0b4e02e$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $b2bc56c6c0b4e02e$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $b2bc56c6c0b4e02e$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph
    };
}
function $b2bc56c6c0b4e02e$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $b2bc56c6c0b4e02e$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$b2bc56c6c0b4e02e$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $b2bc56c6c0b4e02e$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $b2bc56c6c0b4e02e$var$Ue(e) {
    return e.replace($b2bc56c6c0b4e02e$var$re, "$1");
}
function $b2bc56c6c0b4e02e$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $b2bc56c6c0b4e02e$var$He = (e, t, n)=>({
        children: $b2bc56c6c0b4e02e$var$De(t, e[1], n)
    });
function $b2bc56c6c0b4e02e$var$Fe() {
    return {};
}
function $b2bc56c6c0b4e02e$var$Pe() {
    return null;
}
function $b2bc56c6c0b4e02e$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $b2bc56c6c0b4e02e$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $b2bc56c6c0b4e02e$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $b2bc56c6c0b4e02e$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $b2bc56c6c0b4e02e$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $b2bc56c6c0b4e02e$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $b2bc56c6c0b4e02e$var$t({}, n, l, {
            className: $b2bc56c6c0b4e02e$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($b2bc56c6c0b4e02e$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $b2bc56c6c0b4e02e$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($b2bc56c6c0b4e02e$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $5uXOq.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($b2bc56c6c0b4e02e$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($b2bc56c6c0b4e02e$var$O) && (e = e.replace($b2bc56c6c0b4e02e$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $b2bc56c6c0b4e02e$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($b2bc56c6c0b4e02e$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($b2bc56c6c0b4e02e$var$L.test(p) || $b2bc56c6c0b4e02e$var$B.test(p)) && (n[d] = $5uXOq.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$b2bc56c6c0b4e02e$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $b2bc56c6c0b4e02e$export$3e2338ea76b578c9, i.slugify = i.slugify || $b2bc56c6c0b4e02e$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $b2bc56c6c0b4e02e$var$t({}, $b2bc56c6c0b4e02e$var$a, i.namedCodesToUnicode) : $b2bc56c6c0b4e02e$var$a, i.createElement = i.createElement || $5uXOq.createElement;
    const Z = [], q = {}, Q = {
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.blockQuote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($b2bc56c6c0b4e02e$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakLine]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$f),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakThematic]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$h),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeFenced]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeInline]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnoteReference]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $b2bc56c6c0b4e02e$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.gfmTask]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading]: {
            match: $b2bc56c6c0b4e02e$var$Be(i.enforceAtxHeadings ? $b2bc56c6c0b4e02e$var$w : $b2bc56c6c0b4e02e$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[2], n),
                    id: i.slugify(e[2], $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.headingSetext]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($b2bc56c6c0b4e02e$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $b2bc56c6c0b4e02e$var$Ce.some((e)=>e.test(c)) ? $b2bc56c6c0b4e02e$var$Ne : $b2bc56c6c0b4e02e$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $b2bc56c6c0b4e02e$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlComment]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$T),
            order: 1,
            parse: ()=>({}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.image]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$je(t, e[1], n),
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $b2bc56c6c0b4e02e$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                };
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList]: $b2bc56c6c0b4e02e$var$be(d, 1),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.unorderedList]: $b2bc56c6c0b4e02e$var$be(d, 2),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$k),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: ()=>"\n"
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph]: {
            match: $b2bc56c6c0b4e02e$var$Re,
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.ref]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refImage]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refLink]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$j),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($b2bc56c6c0b4e02e$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textBolded]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEmphasized]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEscaped]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textMarked]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$J),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$K),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock], delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($b2bc56c6c0b4e02e$var$x, "\n").replace($b2bc56c6c0b4e02e$var$S, "").replace($b2bc56c6c0b4e02e$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $b2bc56c6c0b4e02e$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $b2bc56c6c0b4e02e$var$n);
    return $5uXOq.cloneElement($b2bc56c6c0b4e02e$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("aRS1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $270fc2c4bbd80c91$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $270fc2c4bbd80c91$var$listStyles = null;
const $270fc2c4bbd80c91$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        ...props,
        className: (0, $bwpsq.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $270fc2c4bbd80c91$export$2e2bcd8739ae039 = $270fc2c4bbd80c91$var$UList;

});


parcelRegister("aBTst", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8d8f80d50d9d1e4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $a8d8f80d50d9d1e4$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $5uXOq.useState)(0);
    const ref = (0, $5uXOq.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $5uXOq.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $a8d8f80d50d9d1e4$export$2e2bcd8739ae039 = $a8d8f80d50d9d1e4$export$6118ed0013927eb2;

});

parcelRegister("adeuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $749bb6d43c83bff0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $749bb6d43c83bff0$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $749bb6d43c83bff0$export$2e2bcd8739ae039 = $749bb6d43c83bff0$var$AIEventSummaryViewed;

});



parcelRegister("85ffk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cb2203e6787402$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $obtkX = parcelRequire("obtkX");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $d5cb2203e6787402$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $obtkX.default), {
        ...props,
        testId: testId
    });
};
var $d5cb2203e6787402$export$2e2bcd8739ae039 = $d5cb2203e6787402$var$AIFooterBlock;

});
parcelRegister("obtkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6b56bbc6d143050$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $kBKwT = parcelRequire("kBKwT");
const $f6b56bbc6d143050$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kBKwT.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $f6b56bbc6d143050$export$2e2bcd8739ae039 = $f6b56bbc6d143050$var$AIFooterBlockResolvedView;

});
parcelRegister("kBKwT", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $84dc366e320e5880$export$175228cc2c92b3b6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $jps85 = parcelRequire("jps85");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $3bDjY = parcelRequire("3bDjY");

var $7zaVw = parcelRequire("7zaVw");

var $1MeuC = parcelRequire("1MeuC");

var $8z1HA = parcelRequire("8z1HA");

var $c8Sqt = parcelRequire("c8Sqt");
const $84dc366e320e5880$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { state: { status: status } } = (0, $1MeuC.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8Sqt.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $8z1HA.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("c8Sqt", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $a035773c38c242b5$export$2957fc44b3d2481);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2Yv61 = parcelRequire("2Yv61");

var $lqBg9 = parcelRequire("lqBg9");
const $a035773c38c242b5$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $lqBg9.default),
        ...props
    });

});
parcelRegister("lqBg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f1ed3211c768fe6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $4f1ed3211c768fe6$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $4f1ed3211c768fe6$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $4f1ed3211c768fe6$var$InfoIconGlyph
    });
var $4f1ed3211c768fe6$export$2e2bcd8739ae039 = $4f1ed3211c768fe6$var$InfoIcon;

});





parcelRegister("fh9qw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b695424587865b74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $jRHKj = parcelRequire("jRHKj");

var $s2ak7 = parcelRequire("s2ak7");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b695424587865b74$var$ignoreContainerPaddingStylesOld = null;
const $b695424587865b74$var$ignoreContainerPaddingStyles = null;
const $b695424587865b74$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $b695424587865b74$var$sort = (a, b)=>{
    let idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $b695424587865b74$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $b695424587865b74$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $gKZoD.di)((0, $s2ak7.ActionFooter));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $b695424587865b74$export$1af10e3728e3a644(ui?.size || (0, $8dVIb.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $5uXOq.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($b695424587865b74$var$sort);
        return arr.map((name)=>{
            const Action = name in $jRHKj ? $jRHKj[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g" : "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb1osq _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $s2ak7.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $b695424587865b74$export$2e2bcd8739ae039 = $b695424587865b74$var$ActionBlock;

});
parcelRegister("s2ak7", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $e384e6334b5a98a7$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $059q9 = parcelRequire("059q9");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $aBTst = parcelRequire("aBTst");
const $e384e6334b5a98a7$var$containerStyles = null;
const $e384e6334b5a98a7$var$errorStyles = null;
const $e384e6334b5a98a7$var$styles = {
    containerStyles: "_kkk2n7od _2rkoglpi _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $e384e6334b5a98a7$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
            });
        default:
            return null;
    }
};
const $e384e6334b5a98a7$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $e384e6334b5a98a7$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $e384e6334b5a98a7$var$styles.errorContentStyles,
                children: [
                    message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $e384e6334b5a98a7$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testId": `${testId}-footer`,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _2rkoglpi _1yt412x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _vwz4gktf _1bsb1osq _fiawglyw",
            message.appearance === 'error' && "_bfhk1gly"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $e384e6334b5a98a7$var$styles.errorContentStyles,
                children: [
                    message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $e384e6334b5a98a7$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});




parcelRegister("i41Ob", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $b4c0875f37c33ad9$export$1ca0544321134ad6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bMldO = parcelRequire("bMldO");

const $b4c0875f37c33ad9$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMldO.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $b18b5009ce608fe8$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
parcelRegister("bMldO", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $d0b446175f31475d$export$ce508304ed2dd145);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kkxZO = parcelRequire("kkxZO");
class $d0b446175f31475d$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkxZO.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("kkxZO", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $2ed7f4f9fecd197d$export$b89a827e9254211a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4URMI = parcelRequire("4URMI");

var $8RHvB = parcelRequire("8RHvB");
const $2ed7f4f9fecd197d$export$b89a827e9254211a = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $4URMI.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $8RHvB.WrapperAnchor) : (0, $8RHvB.WrapperSpan);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("8RHvB", function(module, exports) {

$parcel$export(module.exports, "WrapperSpan", () => $7f29852863f1f016$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $7f29852863f1f016$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $7f29852863f1f016$var$lineHeight = 22;
const $7f29852863f1f016$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $7f29852863f1f016$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $7f29852863f1f016$var$baseWrapperStylesNew = null;
const $7f29852863f1f016$var$baseWrapperStylesOld = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $7f29852863f1f016$var$interactiveStyles = null;
const $7f29852863f1f016$var$hoveredStyles = null;
const $7f29852863f1f016$var$hoveredWithBackgroundStyles = null;
const $7f29852863f1f016$var$withoutBackgroundStyles = null;
const $7f29852863f1f016$var$withBackgroundStyles = null;
const $7f29852863f1f016$var$truncateStylesNew = null;
const $7f29852863f1f016$var$truncateStylesOld = null;
const $7f29852863f1f016$var$notSelectedStyle = null;
const $7f29852863f1f016$var$selectedStyles = null;

});



const $b18b5009ce608fe8$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("5HNFf", function(module, exports) {

let $42777e3129bc7bce$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $42777e3129bc7bce$var$load("h2MrD"),
    $42777e3129bc7bce$var$load("bYT2S"),
    $42777e3129bc7bce$var$load("ij5kv")
]).then(()=>parcelRequire('6Of57'));

});



parcelRegister("dn5wJ", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $b402a0f22139e437$export$f40b7e0b762b928b);
var $b402a0f22139e437$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});



//# sourceMappingURL=async-issue-field-single-line-smart-link.44fa4980.js.map
